// AUTO-GENERATED by scripts/import-wechat.mjs — do not edit.
// Source: CEUS 碳捕集与能源利用数智实验室公众号归档（2026-10-29）

export type ArticleBlock = {
  type: 'h2' | 'h3' | 'p' | 'quote' | 'img' | 'list';
  text?: string;
  items?: string[];
  src?: string;
  caption?: string;
};

export type WechatArticle = {
  id: string;
  slug: string;
  title: string;
  date: string;
  source: string;
  primary: string;
  projects: string[];
  summary: string;
  cover: string | null;
  images: number;
  blocks: ArticleBlock[];
};

export const articles: WechatArticle[] = [
  {
    "id": "2026-10-22-2a-THEgq",
    "slug": "2a-THEgqK2DYLNPSFpu1IA",
    "title": "热烈祝贺课题组硕士毕业生周艺航入选《2026年中国科协青年科技人才培育工程博士生专项计划》",
    "date": "2026-10-22",
    "source": "https://mp.weixin.qq.com/s/2a-THEgqK2DYLNPSFpu1IA",
    "primary": "news",
    "projects": [
      "news"
    ],
    "summary": "硕士毕业生周艺航入选 2026 年中国科协青年科技人才培育工程博士生专项计划。",
    "cover": "/research/wechat/2026-10-22-2a-THEgqK2DYLNPSFpu1IA/img02.webp",
    "images": 4,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2026-10-22-2a-THEgqK2DYLNPSFpu1IA/img02.webp"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "热烈祝贺课题组**硕士毕业生周艺航**入选2026年**中国科协青年科技人才培育工程博士生专项计划**。"
      },
      {
        "type": "p",
        "text": "周艺航，2022年9月-2025年6月于本课题组就读，研究方向为航运碳捕集，硕士期间发表一区TOP SCI论文3篇。现在天津大学攻读博士学位，师从邓帅教授。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-22-2a-THEgqK2DYLNPSFpu1IA/img03.webp"
      },
      {
        "type": "h3",
        "text": "个人简介"
      },
      {
        "type": "p",
        "text": "周艺航，男，中共党员，现为天津大学工程热物理专业博士研究生，硕士毕业于上海海事大学动力工程及工程热物理专业。主要从事船舶低碳能源系统、二氧化碳资源化利用及多能源系统智能协同优化方面的研究。"
      },
      {
        "type": "p",
        "text": "截至目前，累计发表学术论文9篇，其中SCI论文6篇、中文期刊论文2篇、国际会议论文1篇。相关研究聚焦于IMO减排法规下船舶低碳系统的设计与优化、二氧化碳资源化利用、LNG冷能梯级利用以及纳米流体强化胺吸收法捕集二氧化碳。同时担任《Separation and Purification Technology》《International Journal of Hydrogen Energy》《Carbon Capture Science & Technology》《Applied Thermal Engineering》等期刊审稿人。"
      },
      {
        "type": "p",
        "text": "入选2026年中国科协青年科技人才培育工程博士生专项计划，曾获2025年上海市优秀毕业生、2024年研究生国家奖学金、2024年度《制冷与空调》优秀论文奖、陆军工程大学“四有”优秀学员等荣誉奖励。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-22-2a-THEgqK2DYLNPSFpu1IA/img04.webp"
      },
      {
        "type": "h3",
        "text": "中国科协青年科技人才培育工程"
      },
      {
        "type": "h3",
        "text": "博士生专项计划"
      },
      {
        "type": "p",
        "text": "该工程是中国科协整合政府和社会资源，面向广大青年科技人员实施的能力提升项目。 其旨在聚焦国家重大战略需求，培育处于“塔基”阶段的青年科技人才。 工程的目标是通过系统化的培育，帮助青年科技人才坚定理想信念、夯实理论功底、拓展专业（工程）视野、提升创新能力，打造卓越工程师和科研后备队伍。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-22-2a-THEgqK2DYLNPSFpu1IA/img05.webp"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2026-10-19-ZqlGevkj",
    "slug": "ZqlGevkj34Vk-XaRqA11BA",
    "title": "高分辨率船舶排放清单、时空分析与智能代理模型",
    "date": "2026-10-19",
    "source": "https://mp.weixin.qq.com/s/ZqlGevkj34Vk-XaRqA11BA",
    "primary": "extra",
    "projects": [
      "extra"
    ],
    "summary": "以港口全年 AIS 数据构建 500 m 网格化船舶排放清单，结合空间热点分析与 LSBOOST 代理模型做小时级排放预测，完整参数下 R² 达 0.99。",
    "cover": "/research/wechat/2026-10-19-ZqlGevkj34Vk-XaRqA11BA/img03.webp",
    "images": 10,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2026-10-19-ZqlGevkj34Vk-XaRqA11BA/img02.webp"
      },
      {
        "type": "p",
        "text": "https://doi.org/10.1016/j.oceaneng.2026.126230"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "在全球航运脱碳背景下，港口船舶碳排放治理正由总量粗算向精细化、时空化、智能化管控转型。本文选取A港口作为研究案例，构建一套融合精细化排放核算、空间统计分析与智能代理模型的一体化研究框架。基于船舶 AIS 数据构建高分辨率网格化排放清单，识别出集装箱类船舶为首要排放来源，船舶排放表现出显著月际波动特征。借助 Moran’s I 指数证实船舶碳排放存在显著空间自相关特征，热点分析识别出部分水域为高排放聚集区域。本研究以船舶小时为样本单元，构建基于 LSBOOST 算法的智能代理预测模型。该模型在参数完整条件下预测性能优异，在关键参数缺失的现实场景中仍具备较强鲁棒性；结合蒙特卡洛模拟完成排放估算的不确定性量化，验证模型可靠性。研究成果可为港口船舶碳减排策略制定提供系统的科学支撑。"
      },
      {
        "type": "h3",
        "text": "01 研究背景"
      },
      {
        "type": "p",
        "text": "全球航运业是温室气体重要排放来源，国际海事组织数据显示 2018 年航运碳排放约占全球总排放 3%，航运脱碳压力持续增大。我国提出 “双碳” 战略目标，作为海运贸易大国，我国在全球航运减排中肩负重要责任。港口作为海运网络关键枢纽，船舶碳排放问题日益受到重视，但多数港口仍存在排放基线模糊、管控手段粗放等现实难题。"
      },
      {
        "type": "p",
        "text": "AIS 船舶自动识别系统能够记录船舶位置、航速等动态信息，为船舶排放精细化测算提供数据支撑。现有船舶碳排放核算分为自上而下与自下而上两类方法：自下而上法精度更高，但属于回溯式核算，高度依赖完整船舶参数，参数缺失时难以实现实时动态监管。"
      },
      {
        "type": "p",
        "text": "当前船舶碳排放预测多聚焦区域宏观尺度，面向船舶的精细化预测较少，多数机器学习模型假设参数完整，缺少适配港口实际参数缺失场景的研究。部分枢纽港口亟需建立高分辨率排放清单与智能预测模型，支撑船舶碳排放精细化治理。**图1**展示了本文的研究框架。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-19-ZqlGevkj34Vk-XaRqA11BA/img03.webp"
      },
      {
        "type": "h3",
        "text": "图1.研究框架"
      },
      {
        "type": "h3",
        "text": "02 研究设计与数据处理"
      },
      {
        "type": "h3",
        "text": "1. 研究区域"
      },
      {
        "type": "p",
        "text": "选取某港口作为实证研究对象，该港口为区域核心集装箱枢纽港，港区划分为东西两大片区：东部港区以海湾内集装箱码头为核心；西部港区沿海岸带呈条带状分布，包含多个重要码头。该港口水域船舶活动密集，适合开展船舶碳排放实证分析。"
      },
      {
        "type": "h3",
        "text": "2. 数据及预处理"
      },
      {
        "type": "p",
        "text": "本研究采用全年AIS船舶数据，包含船舶静态与动态信息，结合港口数据库、文献排放因子开展研究。 AIS数据预处理主要步骤：①统一数据单位格式，剔除传输错误、重复记录；③利用不同船型拟合公式补全缺失的船长、总吨、主机功率、最大航速等静态参数；④滤除航速越界、位置跳变、陆上轨迹等无效样本。"
      },
      {
        "type": "h3",
        "text": "3. 研究方法"
      },
      {
        "type": "p",
        "text": "**1)自下而上排放核算：**仅计算主机与辅机碳排放，将船舶航行划分为正常巡航、慢速巡航、机动航行、停泊 4 种工况。依据螺旋桨定律计算主机负载因子，低负载工况下采用低负载修正系数校正排放因子；辅机功率通过与主机功率固定比值获取。"
      },
      {
        "type": "p",
        "text": "**2)空间网格处理：**借助 ArcGIS 建立**500 m×500 m**网格，通过空间连接实现排放的空间网格化分配。"
      },
      {
        "type": "p",
        "text": "**3)空间统计分析：**采用全局 Moran’s I 指数分析排放全局空间自相关特征；采用 Getis Ord* 热点分析识别局部高、低排放集聚区域。"
      },
      {
        "type": "p",
        "text": "**4)不确定性分析：**蒙特卡洛模拟，基于拟合残差设置参数波动，经过 10000 次迭代得到排放总量 95% 置信区间，评估清单不确定性。"
      },
      {
        "type": "p",
        "text": "**5)智能代理预测模型：**以船舶 小时为样本单元，选取 6 项输入特征，对比 BPNN、LSBOOST、DT、BiGRU、AdaBoost 五种模型；以R2、RMSE、MAE 作为评价指标；设置多组参数缺失情景检验模型鲁棒性，另外开展大型船舶样本测试检验模型泛化能力。"
      },
      {
        "type": "h3",
        "text": "03主要研究结果"
      },
      {
        "type": "h3",
        "text": "1. 船舶碳排放核算结果"
      },
      {
        "type": "p",
        "text": "完成港口船舶碳排放总量核算，蒙特卡洛模拟得到排放总量95%置信区间，核算结果可信度较高。从船型贡献来看，集装箱船是首要排放源，主要源于集装箱船挂靠频次高、主机输出功率大；其次为拖轮，其余船型排放占比相对有限。从航行工况来看，正常巡航工况排放占比最高，主要是该工况下主机长时间高功率运转。时间维度排放表现出显著周期性：月度排放存在明显高低峰变化，排放变化受航运贸易周期驱动，全港排放水平主要由集装箱船活动强度决定；小时尺度上，集装箱船排放集中在日间时段，显著高于夜间排放水平。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-19-ZqlGevkj34Vk-XaRqA11BA/img04.webp"
      },
      {
        "type": "h3",
        "text": "图2 不同船型不同工况碳排放占比图"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-19-ZqlGevkj34Vk-XaRqA11BA/img05.webp"
      },
      {
        "type": "h3",
        "text": "图3 不同航行工况下碳排放占比"
      },
      {
        "type": "h3",
        "text": "2. 碳排放时空集聚特征"
      },
      {
        "type": "p",
        "text": "空间层面，船舶排放集中分布在港口核心作业区；部分季度排放强度显著高于其余季度。全局 Moran’s I 计算结果表明，各季度船舶碳排放均存在显著正向空间自相关，部分季度空间集聚效应最强。Getis‑Ord*热点分析结果显示，部分港区及海湾水域为典型高排放热点区域，成因在于泊位占用率高、航道拥堵、船舶锚泊等待时间较长；部分航道为排放冷点，得益于船舶航行调度优化，单位面积排放水平偏低；热点斑块会随季度发生扩张、收缩，直观反映航运活动的时空动态变化规律。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-19-ZqlGevkj34Vk-XaRqA11BA/img06.webp"
      },
      {
        "type": "h3",
        "text": "(a)"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-19-ZqlGevkj34Vk-XaRqA11BA/img07.webp"
      },
      {
        "type": "h3",
        "text": "(b)"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-19-ZqlGevkj34Vk-XaRqA11BA/img08.webp"
      },
      {
        "type": "h3",
        "text": "(c)"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-19-ZqlGevkj34Vk-XaRqA11BA/img09.webp"
      },
      {
        "type": "h3",
        "text": "(d)"
      },
      {
        "type": "h3",
        "text": "图4 船舶碳排放季度空间分布(a) - (d):第一季度-第四季度"
      },
      {
        "type": "h3",
        "text": "3. 智能代理预测模型结果"
      },
      {
        "type": "p",
        "text": "在参数完整的理想条件下，5 种对比模型中**LSBOOST 模型性能最优**，决定系数R2达到 0.99，RMSE 仅 0.03；BiGRU 次之，BPNN 表现中等，DT 与 AdaBoost 预测效果相对较差。"
      },
      {
        "type": "p",
        "text": "多场景参数缺失模拟实验：设置单变量缺失、多变量联合缺失、靠泊结构化缺失、全局随机缺失四类情景。LSBOOST 在全部情景下R2均大于 0.90；主机功率缺失对预测精度影响最大；结构化缺失条件下模型性能优于全局随机缺失，面对多关键参数同时缺失依旧保持可靠估算能力。"
      },
      {
        "type": "p",
        "text": "泛化能力测试：使用完全未参与训练的大型船舶样本测试，得到R2=0.98、RMSE=0.16，模型可以捕捉港口船舶通用排放规律，具备良好外推能力。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-19-ZqlGevkj34Vk-XaRqA11BA/img10.webp"
      },
      {
        "type": "h3",
        "text": "图5 多模型测试集预测效果图"
      },
      {
        "type": "h3",
        "text": "04核心结论与展望"
      },
      {
        "type": "h3",
        "text": "1. 核心结论"
      },
      {
        "type": "p",
        "text": "**1) 排放总量与来源特征**：集装箱船为港口最主要排放源。排放存在明显季节周期，航行工况中正常巡航贡献绝大部分碳排放。"
      },
      {
        "type": "p",
        "text": "**2) 时空分布特征**：船舶碳排放表现显著正向空间自相关，部分港区水域属于高排放集聚热点。航道拥堵、锚泊等待时间长、船舶频繁变速操纵是该区域排放集中的主要诱因，排放热点会伴随航运业务淡旺季动态演变。"
      },
      {
        "type": "p",
        "text": "**3) 智能代理模型效果**：LSBOOST 模型综合性能最优。针对港口普遍存在的关键参数缺失问题，多类缺失场景下模型依旧保持较高鲁棒性；对未参与训练的大型船舶样本同样具备优秀泛化能力，可充当虚拟传感器，弥补传统自下而上核算高度依赖完备参数的短板，支撑动态实时排放估算。"
      },
      {
        "type": "h3",
        "text": "2. 未来研究方向"
      },
      {
        "type": "p",
        "text": "后续研究将融合AIS、岸电运行记录、港口调度多源异构数据，校正船舶靠泊阶段排放估算偏差，完善港口船舶精细化排放估算体系。面向高排放热点区域，进一步探究岸电推广、泊位调度优化、船舶到港时序调整等低碳管控手段，形成可落地的船舶减排实施方案，为港口船舶低碳治理提供理论依据与技术支撑。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-19-ZqlGevkj34Vk-XaRqA11BA/img11.webp"
      },
      {
        "type": "p",
        "text": "攥稿：师敏"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2026-10-14-5TLv8smD",
    "slug": "5TLv8smDZAW0CeGVcqzoaA",
    "title": "课题组研究生参加国际碳捕集协会2026会议并作口头报告",
    "date": "2026-10-14",
    "source": "https://mp.weixin.qq.com/s/5TLv8smDZAW0CeGVcqzoaA",
    "primary": "shipborne",
    "projects": [
      "shipborne"
    ],
    "summary": "IACC 2026 口头报告：以 LNG 燃料集装箱船为对象，用 HYSYS 建立主机余热驱动 MEA 捕集流程，研究富液进料位置与液气比对再生能耗的影响。",
    "cover": "/research/wechat/2026-10-14-5TLv8smDZAW0CeGVcqzoaA/img03.webp",
    "images": 4,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2026-10-14-5TLv8smDZAW0CeGVcqzoaA/img02.webp"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "2026年8月26—29日，**国际碳捕集协会2026会议（IACC 2026）**在陕西西安举行。本次会议由西安交通大学主办，吸引了来自15个国家的200余名专家学者、青年科研人员和企业技术人员参加，共同交流碳捕集、利用与封存及低碳能源技术领域的研究进展。**我课题组博士研究生吴宇恒**参加了此次会议，并在液体溶剂碳捕集分会场作了题为**《Parameter Case Studies of Onboard Carbon Capture》（船载碳捕集流程参数案例研究）的口头报告**，分享了课题组在主机余热约束下船载碳捕集流程参数研究方面的进展。"
      },
      {
        "type": "h3",
        "text": "01 报告摘要"
      },
      {
        "type": "p",
        "text": "围绕船载碳捕集系统的富液进料位置和液气比开展研究，结合溶液CO₂负载差与再生热量分配，分析了两类参数对系统能耗和减排性能的影响。该研究为课题组进一步开展船载碳捕集流程优化及航次尺度减排评估提供了参考。"
      },
      {
        "type": "h3",
        "text": "02 报告内容"
      },
      {
        "type": "p",
        "text": "该研究针对船载碳捕集系统余热供给有限、再生能耗较高的问题，以LNG燃料集装箱船为对象，采用乙醇胺（MEA）水溶液作为吸收剂，基于HYSYS建立主机余热驱动的碳捕集流程模型，分别研究富液进料位置和液气比对系统性能的影响。模拟结果表明，适当下移富液进料位置可改善再生热量分配，降低再生比能耗，并提高余热约束下的减排率；合理选择液气比有助于兼顾溶液循环量与再生能耗，而液气比过高则会增加溶液显热需求，不利于余热利用。该研究为船载碳捕集系统的流程参数选择与性能优化提供了参考。会议期间，吴宇恒还与我课题组硕士毕业生、现于天津大学攻读博士学位的周艺航师兄交流了各自的研究进展和学习体会，并向师兄请教了科研经验。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-14-5TLv8smDZAW0CeGVcqzoaA/img03.webp",
        "caption": "图1.吴宇恒做口头报告"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-14-5TLv8smDZAW0CeGVcqzoaA/img04.webp",
        "caption": "图2.毕业生周艺航（天大在读博士）与吴宇恒"
      },
      {
        "type": "h3",
        "text": "03 国际碳捕集协会 简介"
      },
      {
        "type": "p",
        "text": "国际碳捕集协会会议是碳捕集领域的国际学术交流平台，旨在促进碳捕集技术研究与应用，加强高校、科研机构和产业界的交流合作。本届会议涵盖液体溶剂吸收、固体吸附、膜分离、直接空气捕集、碳捕集与利用一体化及过程建模与人工智能等方向，通过大会报告、分会场报告和墙报展示等形式，分享相关领域的最新研究成果，为专家学者和青年科研人员了解前沿动态、开展交流合作提供平台。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-14-5TLv8smDZAW0CeGVcqzoaA/img05.webp"
      },
      {
        "type": "p",
        "text": "攥稿：吴宇恒"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2026-10-11-8ltEGqI9",
    "slug": "8ltEGqI9_N_BP3bBU7WcGA",
    "title": "喜报｜课题组教师入选斯坦福大学全球前 2% 顶尖科学家榜单（2026年度）",
    "date": "2026-10-11",
    "source": "https://mp.weixin.qq.com/s/8ltEGqI9_N_BP3bBU7WcGA",
    "primary": "news",
    "projects": [
      "news"
    ],
    "summary": "田镇教授、高文忠教授、张远副教授入选斯坦福大学全球前 2% 顶尖科学家榜单。",
    "cover": "/research/wechat/2026-10-11-8ltEGqI9_N_BP3bBU7WcGA/img03.webp",
    "images": 5,
    "blocks": [
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "恭喜**田镇教授（连续3年）**，**高文忠教授（1年）**，**张远副教授（连续2年）**成功入选2024-2026发布版**全球前2%顶尖科学家“年度科学影响力排行榜”**。此次入选该榜单，彰显了课题组教师在动力工程领域持续稳定的国际学术影响力，更是其多年潜心钻研、聚力产出高质量科研成果的有力见证。"
      },
      {
        "type": "h3",
        "text": "荣誉简介"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-11-8ltEGqI9_N_BP3bBU7WcGA/img02.webp"
      },
      {
        "type": "p",
        "text": "田镇教授任职于上海海事大学，研究方向为动力工程及工程热物理下的LNG冷能利用与船舶碳捕集、微小尺度强化传热等。根据榜单披露信息，此次评选的H-index为12，Hm-index为6，在该细分学科领域全球排名1766位。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-11-8ltEGqI9_N_BP3bBU7WcGA/img03.webp"
      },
      {
        "type": "p",
        "text": "**高文忠教授**任职于上海海事大学，研究方向为LNG冷能发电关键技术、CO2捕集技术、固体储氢与用氢。根据榜单披露信息，此次评选的H-index为10，Hm-index为5，在该细分学科领域全球排名2840位。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-11-8ltEGqI9_N_BP3bBU7WcGA/img04.webp"
      },
      {
        "type": "p",
        "text": "**张远副教授**任职于上海海事大学，研究方向为LNG冷能梯级利用与碳捕集、海洋温差发电技术、热力系统集成优化与动态仿真。根据榜单披露信息，此次评选的H-index为13，Hm-index为6，在该细分学科领域全球排名5088位。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-11-8ltEGqI9_N_BP3bBU7WcGA/img05.webp"
      },
      {
        "type": "h3",
        "text": "榜单介绍"
      },
      {
        "type": "p",
        "text": "**球前2%顶尖科学家榜单（World’s Top 2% Scientists 2026）介绍**"
      },
      {
        "type": "p",
        "text": "该榜单由斯坦福大学John P.A. Ioannidis团队联合Elsevier发布，是目前国际上广受关注的学者学术影响力参考评价体系。榜单基于2026年8月1日Scopus数据库快照，终身影响力数据统计截止至2025年末，年度影响力榜单统计学者**2025 自然年度获得的引用数据**，采用Science‑Metrix标准化学科分类，覆盖20个科学领域、174个细分子领域。"
      },
      {
        "type": "p",
        "text": "**年度科学影响力排行榜**，聚焦学者单一年度的科研产出、创新突破与学术贡献。评价体系摒弃单一论文数量导向，依托综合C‑score指标，综合考量论文总被引频次、H指数、经合著贡献修正的Hm指数、独立作者及第一/通讯位置论文引用情况等多维度信息，从全球海量科研人员中遴选出各子领域学术表现位列前2%的科学家。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-11-8ltEGqI9_N_BP3bBU7WcGA/img06.webp"
      },
      {
        "type": "p",
        "text": "攥稿：张倩玮"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2026-10-10-Rgp34oUZ",
    "slug": "Rgp34oUZ4J91enoQIxGoNg",
    "title": "课题组成员参加第十八届国际能源应用大会（ICAE）并进行报告",
    "date": "2026-10-10",
    "source": "https://mp.weixin.qq.com/s/Rgp34oUZ4J91enoQIxGoNg",
    "primary": "shipborne",
    "projects": [
      "shipborne"
    ],
    "summary": "ICAE 2026 四项报告，涵盖船载碳捕集动态匹配控制、AIS 排放预测与富液沸腾解吸仿生表面 CFD；仿生表面稳定段热流提高 36.7%，CO2 产量提高 47.1%。",
    "cover": "/research/wechat/2026-10-10-Rgp34oUZ4J91enoQIxGoNg/img04.webp",
    "images": 6,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2026-10-10-Rgp34oUZ4J91enoQIxGoNg/img02.webp"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "第十八届**国际应用能源大会ICAE（International Conference on Applied Energy）**于2026年9月22日至26日在韩国济州岛-济州国际会展中心隆重举行。本届会议主题为“融合人工智能与应用能源，迈向全球可持续发展”。当前，人工智能的飞速发展正在推动全球能源系统的转型升级，同时也对能源基础设施提出了新的需求。ICAE2026将围绕这一双向互动关系展开深入研讨，聚焦\"AI for Energy\"与\"Energy for AI\"两大核心议题。会议一方面将重点探讨人工智能如何在能源领域的预测、优化、控制、规划与系统集成等环节实现突破；另一方面，也将深入关注清洁、韧性、高效的能源系统如何支撑人工智能、数据中心及数字基础设施日益增长的电力与冷却需求。会议汇聚来自全球各地的专家学者、行业领袖、政策制定者与创新人才，交流思想、分享洞见，展示应用能源领域的前沿进展。我课题组老师**田镇教授**携三位**博士研究生田奕江、师敏、白云帆**参加此次会议并分别作报告。田镇教授就机器学习的船舶碳排放特征分析与智能代理模型这方面内容作了报告并主持了主题为“能源政策，经济和可持续性”的会议。三位博士研究生分别就船载碳捕集实验、AI驱动航运碳排放预测、碳捕集强化醇胺溶液再生等方面作口头报告，分享他们在相关课题的研究进展。"
      },
      {
        "type": "h3",
        "text": "01 报告摘要"
      },
      {
        "type": "p",
        "text": "**田镇教授**作了题为**《基于机器学习的船舶碳排放特征分析与智能代理模型》**的口头报告;主持了主题为**“能源政策，经济和可持续性”**的会议。"
      },
      {
        "type": "p",
        "text": "博士研究生**田奕江**作了题为**《面向船载碳捕集系统的预测运行：工艺与船舶能量控制的实验研究》**的口头报告。"
      },
      {
        "type": "p",
        "text": "博士研究生**师敏**作了题为**《基于 AIS 数据与深度学习的船舶碳排放特征分析及小时级预测研究》**口头报告。"
      },
      {
        "type": "p",
        "text": "博士研究生**白云帆**作了题为**《面向碳捕集系统低能耗再生的富液沸腾解吸强化机制CFD研究：表面仿生微结构与润湿性的协同作用》**的口头报告。"
      },
      {
        "type": "h3",
        "text": "02 报告内容"
      },
      {
        "type": "h3",
        "text": "《基于机器学习的船舶碳排放特征分析与智能代理模型》"
      },
      {
        "type": "p",
        "text": "面对国际海事组织对碳排放日益严格的监管要求，港口航运碳排放精细化管控需求迫切。该研究以深圳港为研究对象，依托 2024 年全年 AIS 数据，通过自下而上法核算得出港区全年船舶碳排放约 110 万吨，系统揭示了船型结构、月度变化与空间分布的排放规律：集装箱船排放占比居各船型首位，月度排放呈现五月峰值、一月最低的特征。研究重点构建了LSBOOST 碳排放预测代理模型，该代理模型凭借优异的非线性拟合能力与稳定性取得最优表现，R² 可达 0.99。研究成果可为港口碳排放分级管控、减排路径挖掘提供数据依据与模型工具，助力港口航运绿色低碳转型。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-10-Rgp34oUZ4J91enoQIxGoNg/img03.webp",
        "caption": "图1.田镇教授做口头报告"
      },
      {
        "type": "h3",
        "text": "《面向船载碳捕集系统的预测运行：工艺与船舶能量控制的实验研究》"
      },
      {
        "type": "p",
        "text": "介绍了课题组在船载碳捕集系统动态匹配控制方面的最新进展。针对船舶碳捕集系统在变工况下捕集效率与再生能耗难以兼顾的矛盾，该研究搭建了中试级船载碳捕集实验平台，提出以液气比和解吸压力为可调参数、以烟气 CO₂ 浓度和余热蒸汽流量为匹配变量的动态匹配控制方案。实验结果表明，与静态匹配控制相比，该方案避免了\"以能耗换捕集率\"的困境——静态高捕集方案虽将捕集率提高 7.8%，再生能耗却上升 51.4%。经济评价进一步显示，部分余热利用方案在满足 IMO EEDI 第四阶段要求的同时，建设成本下降 32.9%、年化成本下降 33.8%。在 IMO 2023 年温室气体战略设定的减排路径下，该成果为船载碳捕集技术的工程应用提供了一条可核算、可合规的实现路径。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-10-Rgp34oUZ4J91enoQIxGoNg/img04.webp",
        "caption": "图2.博士研究生田奕江做口头报告"
      },
      {
        "type": "h3",
        "text": "《基于 AIS 数据与深度学习的船舶碳排放特征分析及小时级预测研究》"
      },
      {
        "type": "p",
        "text": "全球航运温室气体排放约占全球总排放的 3%，低碳航运已成为行业绿色发展的核心方向。该研究整合船舶 AIS 动态数据与船舶技术参数，通过自下而上法核算小时级碳排放，从运行工况、时间尺度多维度解析排放特征，发现正常航行工况贡献了 80.9% 的碳排放，且排放呈现显著的昼高夜低的小时波动规律。研究构建的 SLSA 深度学习模型在多模型对比中精度最优，R² 达 0.878。该研究将船舶碳排放研究从历史核算延伸至未来动态预测，可为船舶碳排放动态感知、短期调度与低碳航行优化提供技术支撑。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-10-Rgp34oUZ4J91enoQIxGoNg/img05.webp",
        "caption": "图3.博士研究生师敏做口头报告"
      },
      {
        "type": "p",
        "text": "《面向碳捕集系统低能耗再生的富液沸腾解吸强化机制CFD研究：表面仿生微结构与润湿性的协同作用》"
      },
      {
        "type": "p",
        "text": "针对传统光滑传热表面在富液沸腾解吸过程中存在的气泡脱离滞后、局部热阻较大等问题，围绕表面仿生微结构和润湿性协同强化机制开展 CFD 数值模拟研究。基于多相流与多组分传热传质耦合模型，构建具有仿生微结构形貌和表面润湿特性的富液沸腾解吸计算模型。模拟结果表明，表面仿生微结构能够增加有效成核区域并强化气液界面扰动，在恒定壁面温度条件下，仿生表面大幅提升表面传热热流密度，适宜的润湿性有助于促进气泡及时脱离和液体快速补给，亲水平面相比普通平面，在稳定阶段表面热流约提高 36.7%，产生 CO2气体质量约提高 47.1%。二者协同作用可有效改善近壁面传热传质过程，降低传热热阻，强化沸腾解吸。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-10-Rgp34oUZ4J91enoQIxGoNg/img06.webp",
        "caption": "图4.博士研究生白云帆做口头报告"
      },
      {
        "type": "h3",
        "text": "03 会议简介"
      },
      {
        "type": "p",
        "text": "**国际能源利用大会（ICAE）**的正式名称是国际应用能源大会（International Conference on Applied Energy）。它由能源领域顶级期刊《Applied Energy》发起并主办，是应用能源领域最具影响力的国际学术盛会之一。ICAE 旨在为全球学术界、工业界和政府决策者提供一个真正综合性的论坛。其核心目标是促进关于能源技术研发、应用及政策的深入辩论，议题涵盖从能源研发、资源优化，到城市能效标准及气候变化政策等广泛领域，最终为能源可持续发展提供可行的解决方案。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-10-10-Rgp34oUZ4J91enoQIxGoNg/img07.webp"
      },
      {
        "type": "p",
        "text": "攥稿：白云帆"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2026-03-27-nWVCh3H6",
    "slug": "nWVCh3H6wUURl5aox1SqzQ",
    "title": "双结构液冷板热工水力优化：面向高容量船舶电池热管理的响应面分析",
    "date": "2026-03-27",
    "source": "https://mp.weixin.qq.com/s/nWVCh3H6wUURl5aox1SqzQ",
    "primary": "extra",
    "projects": [
      "extra"
    ],
    "summary": "用 Box-Behnken 响应面法优化双结构液冷板的肋片/凹坑参数，给出单目标与多目标最优组合，仿真与实验最高温度偏差小于 2.56%。",
    "cover": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img04.webp",
    "images": 16,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img02.webp"
      },
      {
        "type": "p",
        "text": "https://doi.org/10.1016/j.applthermaleng.2026.129991"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "本文提出一种用于高容量船舶电池的双结构肋-槽液冷板，采用响应面法结合Box-Behnken设计，系统研究了肋片和凹坑数（N）、内切圆半径（R）、肋高（H）与凹坑深度（D）对电池组最高温度（Tmax）、温度标准差（SD）和压降（ΔP）的影响。结果表明：Tmax、SD和ΔP对N、R、H高度敏感，D影响较弱；R与H的交互作用对Tmax和ΔP影响显著，H-D与N-D交互对SD影响显著。单目标优化下，Tmax最低为32.47℃、ΔP最小为1299.31 Pa、SD最小为1.46376℃；多目标优化在Tmax=32.62℃、SD=1.47761℃、ΔP=1909.2Pa时实现综合性能最优。研究为高容量船舶电池液冷板结构优化提供了设计依据。"
      },
      {
        "type": "h3",
        "text": "01 研究背景"
      },
      {
        "type": "p",
        "text": "船舶电动化对锂电池热管理要求更高。液冷板是高功率电池热管理的关键部件，肋片与凹坑结构可增强扰动与换热，但现有研究多集中于单一结构或单因素分析，缺乏多参数交互作用的系统优化。针对高容量船舶电池在高热流密度下的复杂热-流耦合问题，亟需建立多目标优化方法，平衡冷却性能、温度均匀性与能耗。"
      },
      {
        "type": "h3",
        "text": "02 研究方法"
      },
      {
        "type": "h3",
        "text": "1. 物理模型"
      },
      {
        "type": "p",
        "text": "计算单元以及液冷板的结构细节如图1所示，构建由4块高容量电池（容量280 Ah）与两侧微通道液冷板组成的模块。通道截面为1 mm × 4 mm，壁厚1.5 mm，内部对称布置菱形肋片与凹坑结构，两者内切圆半径相同。研究参数范围：N=21~41，R=0.5~1 mm，H=0.1~0.8 mm，D=0.1~0.8 mm。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img03.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img04.webp"
      },
      {
        "type": "h3",
        "text": "图1 物理模型 (a). 电池模型和计算单元 (b). 微通道结构"
      },
      {
        "type": "h3",
        "text": "2. 数值模型"
      },
      {
        "type": "p",
        "text": "采用ANSYS Fluent进行瞬态模拟，电池产热基于Bernardi方程并通过0.5C与0.75C放电实验拟合得到时间相关热源。环境温度设为45℃，入口水温23℃，流速0.1 m/s。发热模型经验证如图2所示，Tmax与实验偏差小于2.56%，网格与时间步长无关性如图3和4所示，满足误差要求。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img05.webp"
      },
      {
        "type": "h3",
        "text": "图2. 在0.5C和0.75C下的实验和仿真最高电池温度的比较"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img06.webp"
      },
      {
        "type": "h3",
        "text": "图3. 时间步长对电池最高温度的影响"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img07.webp"
      },
      {
        "type": "h3",
        "text": "图4. 电池网格密度对最高温度的影响"
      },
      {
        "type": "h3",
        "text": "3. 响应面法"
      },
      {
        "type": "p",
        "text": "采用Box-Behnken设计构建26组参数组合，建立Tmax、SD、ΔP的二阶回归模型，通过方差分析评估因子显著性，利用Derringer函数进行多目标优化，以综合性能为目标寻求最优参数。图5对Tmax、SD和ΔP回归模型的残差分析图。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img08.webp"
      },
      {
        "type": "h3",
        "text": "图5. 响应变量的残差分析图"
      },
      {
        "type": "h3",
        "text": "03结果与讨论"
      },
      {
        "type": "h3",
        "text": "1. 单目标优化"
      },
      {
        "type": "p",
        "text": "**图6、7、8**分别展示的是Tmax、SD和ΔP最小化的优化结果。图9、10、11分别是参数交互作用下Tmax、SD和ΔP的3D响应图。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img09.webp"
      },
      {
        "type": "h3",
        "text": "图6. Tmax最小化的优化结果"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img10.webp"
      },
      {
        "type": "h3",
        "text": "图7. SD最小化的优化结果"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img11.webp"
      },
      {
        "type": "h3",
        "text": "图8. ΔP最小化的优化结果"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img12.webp"
      },
      {
        "type": "h3",
        "text": "图9. 参数交互作用下Tmax的三维响应面"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img13.webp"
      },
      {
        "type": "h3",
        "text": "图10. 参数交互作用下SD的三维响应面"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img14.webp"
      },
      {
        "type": "h3",
        "text": "图11. 参数交互作用下ΔP的三维响应面"
      },
      {
        "type": "h3",
        "text": "2. 多目标优化"
      },
      {
        "type": "p",
        "text": "多目标研究中分析的每个响应的优化目标及重要性见下表："
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img15.webp",
        "caption": "图12展示了针对各响应变量及其运行条件的多重最优目标优化值，该组合在保持良好冷却性能的同时，显著改善了温度均匀性与能耗。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img16.webp"
      },
      {
        "type": "h3",
        "text": "图12. RSM预测结果的阶跃函数图"
      },
      {
        "type": "h3",
        "text": "04核心结论与展望"
      },
      {
        "type": "h3",
        "text": "1. 核心结论"
      },
      {
        "type": "p",
        "text": "(1). Tmax最小化：最优参数为 N = 41、R = 0.9895 mm、H = 0.7976 mm、D = 0.2773 mm，最小 Tmax 为 32.47 ℃。其中 R 与 H 的交互影响最为显著，增加翅片数量与尺寸可有效强化对流换热。"
      },
      {
        "type": "p",
        "text": "(2). ΔP 最小化：最优参数为 N = 27、R = 0.8811 mm、H = 0.1037 mm、D = 0.3048 mm，最小 ΔP 为 1299.31 Pa。N 与 R 的交互作用主导压降变化，增大二者会减小流道截面积、增强流体-壁面作用，从而升高 ΔP。"
      },
      {
        "type": "p",
        "text": "(3). SD 最小化：最优参数为 N = 41、R = 0.5 mm、H = 0.1401 mm、D = 0.1062 mm，最小 SD 为 1.46376 ℃。H 与 D 的交互作用最为关键，合理匹配翅片高度与凹坑深度对改善温度均匀性至关重要。"
      },
      {
        "type": "p",
        "text": "(4). 多目标优化：同时最小化 Tmax、SD 与 ΔP，获得最优参数为 N = 21、R = 0.9848 mm、H = 0.4402 mm、D = 0.6957 mm，对应性能为 Tmax = 32.62 ℃、SD = 1.4776 ℃、ΔP = 1909.2 Pa。验证偏差小于 1%，模型可靠。与直通道相比，优化设计使 Tmax 降低 0.29 ℃，而 ΔP 仅适当增加。"
      },
      {
        "type": "h3",
        "text": "2. 未来研究方向"
      },
      {
        "type": "p",
        "text": "后续可结合实验验证多目标优化结果的可靠性，进一步考虑变工况适应性、流道拓扑优化及肋-凹坑协同设计，提升液冷板在全工况下的综合热工水力性能。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-03-27-nWVCh3H6wUURl5aox1SqzQ/img17.webp"
      },
      {
        "type": "p",
        "text": "攥稿：张久魁"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2026-02-06-fF8S7H9U",
    "slug": "fF8S7H9UmlSTlWGnSUhuuA",
    "title": "AI碳索未来｜基于多源监测信息与新型数据驱动模型的碳捕集试验系统预测及多目标优化",
    "date": "2026-02-06",
    "source": "https://mp.weixin.qq.com/s/fF8S7H9UmlSTlWGnSUhuuA",
    "primary": "extra",
    "projects": [
      "extra"
    ],
    "summary": "基于自建捕集-解吸试验系统的数据驱动预测与多目标优化；随机森林四项指标 R² 均高于 0.98，优化后再生能耗降低约 4.8%。",
    "cover": "/research/wechat/2026-02-06-fF8S7H9UmlSTlWGnSUhuuA/img03.webp",
    "images": 12,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2026-02-06-fF8S7H9UmlSTlWGnSUhuuA/img02.webp"
      },
      {
        "type": "p",
        "text": "https://doi.org/10.1016/j.enconman.2025.120937"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "随着全球减排需求日益迫切，精准预测碳捕集系统性能至关重要。本文基于**随机森林（RF）**、**反向传播神经网络（BPNN）**和**卷积神经网络（CNN）**三种机器学习算法，构建了融合物理约束的碳捕集系统性能预测模型。通过筛选关键操作参数，**模型实现了对CO2输出体积流量、捕集效率、再生能耗与热效能指标的高精度预测**，其中**RF**表现最佳，预测误差低于0.6%。研究进一步提出“预测-优化-决策”协同优化框架，实现了系统多目标优化，结果与实验高度吻合，为高效、低碳的碳捕集系统设计提供了可靠基准。"
      },
      {
        "type": "h3",
        "text": "01 研究背景"
      },
      {
        "type": "p",
        "text": "全球工业化与化石能源消耗持续推高CO₂浓度，导致气候问题日益严峻。实现碳中和已成为国际共识，碳捕集、利用与封存（CCUS）技术被视作关键减排路径之一。近年来，该技术快速发展，逐渐从实验走向规模应用。"
      },
      {
        "type": "p",
        "text": "人工智能（AI）与机器学习（ML）的兴起为碳捕集领域注入新动力。通过数据建模与智能优化，机器学习可提升系统效率、降低能耗，并加速新材料与新工艺研发。然而，当前研究仍存在一些不足：缺乏针对真实实验场景的高质量数据集；未系统比较不同机器学习模型的性能；多数模型未引入物理约束，可能输出不切实际的预测；且缺乏从预测到决策的完整优化框架。"
      },
      {
        "type": "p",
        "text": "为此，本研究围绕醇胺法碳捕集工艺，通过实验构建高质量数据集，对比多种机器学习算法，并嵌入物理约束提升预测可靠性。最终搭建起“预测-优化-决策”一体化框架，为碳捕集系统的智能优化与工程应用提供数据驱动支持。"
      },
      {
        "type": "h3",
        "text": "02 技术路径"
      },
      {
        "type": "h3",
        "text": "1. 实验装置"
      },
      {
        "type": "p",
        "text": "本研究构建了一个**CO₂捕集-解吸试验系统**，其总体示意图如图1所示。这个系统主要由三个子系统组成：CO₂捕集-解吸循环系统负责实现二氧化碳的吸收与再生过程，配气系统用于精确控制气体组分和流量，冷却水循环系统则为整个装置提供稳定的温度调节。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-02-06-fF8S7H9UmlSTlWGnSUhuuA/img03.webp"
      },
      {
        "type": "h3",
        "text": "图1.总体示意图"
      },
      {
        "type": "p",
        "text": "实验装置通过多参数监测实现CO₂捕集-解吸过程的精确控制，关键测量参数包括温度、压力和流量，具体测量点分布如图2所示。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-02-06-fF8S7H9UmlSTlWGnSUhuuA/img04.webp"
      },
      {
        "type": "h3",
        "text": "图2.测点布置"
      },
      {
        "type": "h3",
        "text": "2. 模型构建"
      },
      {
        "type": "p",
        "text": "RF因适配高维数据、抗噪声干扰且泛化能力强，契合碳捕集系统的多参数耦合、实验数据含噪声的特性，其结构图如图3所示。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-02-06-fF8S7H9UmlSTlWGnSUhuuA/img05.webp"
      },
      {
        "type": "h3",
        "text": "图3. RF结构图"
      },
      {
        "type": "p",
        "text": "BPNN因具备优异的非线性拟合能力及局部特征学习优势，契合碳捕集系统运行参数与性能指标间存在的强非线性映射关系，其结构图如图4所示。"
      },
      {
        "type": "h3",
        "text": "图4. BPNN结构图"
      },
      {
        "type": "p",
        "text": "CNN具备自动提取复杂隐藏特征的优势，无需人工特征工程即可提升多指标协同预测精度，适配碳捕集实验数据的时序关联与多维度耦合特性，其结构图如图5所示。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-02-06-fF8S7H9UmlSTlWGnSUhuuA/img07.webp"
      },
      {
        "type": "h3",
        "text": "图5. CNN结构图"
      },
      {
        "type": "h3",
        "text": "03结果分析与讨论"
      },
      {
        "type": "h3",
        "text": "1. 精度分析"
      },
      {
        "type": "p",
        "text": "为系统量化并直观对比RF、BPNN与CNN三种机器学习模型在碳捕集系统性能预测中的精度差异，表1采用多维度评价指标进行综合分析。通过将三种模型一起绘制在图6中，RF是能在所有核心性能指标上均提供高精度、高稳定性预测的模型。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-02-06-fF8S7H9UmlSTlWGnSUhuuA/img08.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-02-06-fF8S7H9UmlSTlWGnSUhuuA/img09.webp"
      },
      {
        "type": "h3",
        "text": "图6. 三种机器学习模型在多个性能指标上的表现"
      },
      {
        "type": "h3",
        "text": "2. 计算资源分析"
      },
      {
        "type": "p",
        "text": "为全面评估模型在实际应用中的综合性能，本研究在预测精度分析的基础上，进一步从计算成本、模型复杂度及鲁棒性三个维度对RF、BPNN与CNN模型进行了系统性对比，结果如表2所示。综合来看，RF在预测精度与计算开销间实现了最佳平衡。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-02-06-fF8S7H9UmlSTlWGnSUhuuA/img10.webp"
      },
      {
        "type": "h3",
        "text": "3. 可解释性分析"
      },
      {
        "type": "p",
        "text": "RF因其最优的预测精度和最为稳定的性能表现，被选定进行SHAP 分析。基于RF模型得出的各输入变量对系统性能影响的SHAP可视化结果如图7所示，充分表明RF模型在保持高预测性能的同时具备良好的可解释性。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-02-06-fF8S7H9UmlSTlWGnSUhuuA/img11.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-02-06-fF8S7H9UmlSTlWGnSUhuuA/img12.webp"
      },
      {
        "type": "h3",
        "text": "图7. shap分析图"
      },
      {
        "type": "h3",
        "text": "4.多目标优化"
      },
      {
        "type": "p",
        "text": "图8展示了基于NSGA-III优化所获得的最优工况点在四个关键性能指标上均全面优于GA所得结果。尤其在CO₂输出能力与再生能耗方面提升显著：CO₂输出流量提高约 5.6%，再生能耗降低约 4.8%；同时热效能与捕集效率也均有改善。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-02-06-fF8S7H9UmlSTlWGnSUhuuA/img13.webp"
      },
      {
        "type": "h3",
        "text": "图8. NSGA-III与GA算法Pareto前沿曲线对比"
      },
      {
        "type": "h3",
        "text": "04结论与展望"
      },
      {
        "type": "h3",
        "text": "1. 结论"
      },
      {
        "type": "p",
        "text": "（1）构建了RF、BPNN与CNN三种机器学习模型，并在模型中嵌入了质量与能量守恒等物理约束。结果表明，RF模型在预测精度、计算效率和可解释性上表现最优。"
      },
      {
        "type": "p",
        "text": "（2）RF模型对关键指标的决定系数R²均高于0.98，平均预测误差低于0.6%，且计算速度最快、结构更易解释。通过SHAP分析发现，关键因素与碳捕集过程机理一致。"
      },
      {
        "type": "p",
        "text": "（3）多目标优化框架得到的最优工况均优于传统方法，其中CO₂输出能力提升5.6%，再生能耗降低4.8%，计算效率提高近28倍。与实验结果对比，所有关键参数误差均小于5%。"
      },
      {
        "type": "h3",
        "text": "2. 未来研究方向"
      },
      {
        "type": "p",
        "text": "（1）扩展 CO₂浓度及长期运行的实验数据覆盖，增强模型泛化能力与鲁棒性。"
      },
      {
        "type": "p",
        "text": "（2）深化物理约束融合，动态平衡拟合精度与物理合理性。"
      },
      {
        "type": "p",
        "text": "（3）推动预测模型与优化框架深度集成，实现过程控制与捕集性能的实时决策支持。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-02-06-fF8S7H9UmlSTlWGnSUhuuA/img14.webp"
      },
      {
        "type": "p",
        "text": "攥稿：顾毓"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2026-01-30-pXlvPe-x",
    "slug": "pXlvPe-xs1iOF1FJW1elcQ",
    "title": "嗑盐小队2025年度年会圆满举行：耕耘 沉淀 启新程",
    "date": "2026-01-30",
    "source": "https://mp.weixin.qq.com/s/pXlvPe-xs1iOF1FJW1elcQ",
    "primary": "news",
    "projects": [
      "news"
    ],
    "summary": "课题组举行“耕耘 沉淀 启新程”主题年会，回顾 2025 年成果并规划新一年方向。",
    "cover": "/research/wechat/2026-01-30-pXlvPe-xs1iOF1FJW1elcQ/img03.webp",
    "images": 5,
    "blocks": [
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "2026年1月14日下午，嗑盐小队举办了以“耕耘 沉淀 启新程”为主题的团建年会。田老师与20位研究生欢聚一堂。会上，团队全面回顾了2025年的奋斗历程与辉煌成果，并对未来的发展方向进行了深入规划。期间穿插的趣味互动游戏与幸运抽奖环节，将现场气氛推向高潮，营造出温馨热烈、团结奋进的良好氛围。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-30-pXlvPe-xs1iOF1FJW1elcQ/img02.webp"
      },
      {
        "type": "h3",
        "text": "活动展示"
      },
      {
        "type": "p",
        "text": "时光奔涌，岁聿云暮。年会伊始，课题组田老师总结2025年嗑盐小队成果发表讲话。她充分肯定了团队在过去一年中取得的科研突破与学术进展，鼓励大家在新的一年里继续保持求知若渴、踏实钻研的精神风貌。随后，每位同学分享了各自的科研心得与项目成果，展现了团队在前沿研究领域的扎实积累与创新活力。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-30-pXlvPe-xs1iOF1FJW1elcQ/img03.webp"
      },
      {
        "type": "p",
        "text": "为增强同学们参与感与归属感，年会精心设计了多个互动游戏环节，团队成员积极参与“绕口令”“幸运抽奖”“狼人杀”等趣味小游戏，气氛融洽。幸运抽奖环节更是将现场推向高潮，每位成员都收获了惊喜与祝福，进一步增强了团队的凝聚力与归属感。现场笑声不断，充分展现了嗑盐团队朝气蓬勃、团结协作的精神风貌。"
      },
      {
        "type": "p",
        "text": "随后,团队成员一起分享了蛋糕，不仅承载着甜蜜的滋味，更寄托着团队对未来的无限期许。愿我们在新的一年里，不惧挑战，勇毅笃行，在学术之路上稳步迈进，奔赴属于我们的星辰大海。这不仅仅是一块蛋糕，更是我们共同的记忆与誓言：以热爱为火，以坚持为炬，共绘属于嗑盐小队的璀璨篇章！"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-30-pXlvPe-xs1iOF1FJW1elcQ/img04.webp"
      },
      {
        "type": "h3",
        "text": "结语"
      },
      {
        "type": "p",
        "text": "此次年会不仅是对2025年工作的深情回望，更是一次思想的碰撞与情感的凝聚。大家纷纷表示，在新的一年里将继续秉持“深耕细作、追求卓越”的信念，以更加饱满的热情投入到科研事业中，携手共进，开启属于磕盐小队的新征程。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-30-pXlvPe-xs1iOF1FJW1elcQ/img05.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-30-pXlvPe-xs1iOF1FJW1elcQ/img06.webp"
      },
      {
        "type": "p",
        "text": "攥稿：师敏"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2026-01-06-x0JpizjJ",
    "slug": "x0JpizjJ_vH-tNUZ02xc_Q",
    "title": "课题组成员参加第十七届全国低温工程大会并作口头报告",
    "date": "2026-01-06",
    "source": "https://mp.weixin.qq.com/s/x0JpizjJ_vH-tNUZ02xc_Q",
    "primary": "pche",
    "projects": [
      "pche"
    ],
    "summary": "第十七届全国低温工程大会报告：锯齿通道 PCHE 低温热工水力实验，结论支持 PCHE 作为 LNG 船 FGSS 低温汽化器。",
    "cover": "/research/wechat/2026-01-06-x0JpizjJ_vH-tNUZ02xc_Q/img03.webp",
    "images": 3,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2026-01-06-x0JpizjJ_vH-tNUZ02xc_Q/img02.webp"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "2025年11月26—28日，**第十七届全国低温工程大会在广东中山成功举办**。本次大会由中国制冷学会低温专业委员会和中山先进低温技术研究院联合主办，《制冷学报》《低温工程》《真空与低温》《低温与超导》《低温与特气》《工程研究-跨学科视野中的工程》六本期刊协办，并得到中山市科学技术局和中山市人民政府南区街道办事处的大力支持。来自全国的千位低温界专家学者、企业代表齐聚一堂，共话低温技术创新突破，共商产业协同发展路径，共绘科技赋能高质量发展的崭新蓝图。**我课题组硕士研究生曾励强**参加了此次会议。"
      },
      {
        "type": "h3",
        "text": "01 报告内容"
      },
      {
        "type": "p",
        "text": "在低温工程大会分会场上，**曾励强**作了题为**《印刷电路板换热器在低温条件下的热工水力性能实验研究》**的口头报告，分享了他们最近在相关课题方向的研究进展。"
      },
      {
        "type": "h3",
        "text": "02 摘要"
      },
      {
        "type": "p",
        "text": "印刷电路板换热器（PCHE）具有优异的热工水力性能和紧凑的结构，是液化天然气船燃料供应系统（FGSS）的理想汽化器。本文以尺寸为214mm×56.5mm×41.5mm的锯齿型通道PCHE作为研究对象，设计并搭建了一个PCHE热工水力性能实验平台，并以液氮(LN)作为冷流体，50%乙二醇水溶液(EG)作为热流体。通过调整EG进口质量流量（983-1621kg/h）、LN进口质量流量（50-110kg/h）和顺/逆流布置进行了传热和流动实验。首先研究了液氮和乙二醇质量流量的变化对流动换热性能的影响，其次比较了PCHE在顺流和逆流布置下的热工水力性能，最后分析了PCHE在低温环境下的冻结影响。结果表明，增加液氮和乙二醇的质量流量会提高换热器的传热性能，且提高液氮质量流量产生的效果更加显著。与顺流相比，PCHE在逆流条件下的换热性能更高，在LN质量流量相同的情况下，逆流排布的换热量要比顺流排布的换热量高出1.1-1.8kW。当换热器局部发生冻结时，其传热性能会显著恶化，且压降也会大幅度提高。该研究为PCHE作为低温蒸发器提供了参考，为其在FGSS中的应用奠定了基础。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-06-x0JpizjJ_vH-tNUZ02xc_Q/img03.webp"
      },
      {
        "type": "h3",
        "text": "03 全国低温工程大会会议简介"
      },
      {
        "type": "p",
        "text": "全国低温工程大会是我国低温工程领域规模最大、规格最高、影响力最广的学术盛会，本届大会的参会热度与学术质量均创历史新高。据统计，赞助单位42家，参会单位超过240家，参会代表人数超过1000人，充分彰显了低温工程技术发展的蓬勃生机与广阔前景。会议旨在交流我国低温技术、超导技术、低温材料及应用的最新成果，探讨低温领域的新思想和新方法，提供学术交流、沟通合作、分享成果的学术平台，推动我国低温技术进一步发展。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-06-x0JpizjJ_vH-tNUZ02xc_Q/img04.webp"
      },
      {
        "type": "p",
        "text": "攥稿：曾励强"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2026-01-04-Qo6TMIVT",
    "slug": "Qo6TMIVTHBvS0fdELjht2g",
    "title": "多源异质能流碳捕集 | 基于冷-热-电-碳转换的船载ORC-CCS系统4E分析与优化",
    "date": "2026-01-04",
    "source": "https://mp.weixin.qq.com/s/Qo6TMIVTHBvS0fdELjht2g",
    "primary": "shipborne",
    "projects": [
      "shipborne"
    ],
    "summary": "以 81190 DWT LNG 散货船为对象，构建串联与并联 ORC-CCS 系统，用 LNG 冷能和缸套水余热驱动解吸与 CO2 液化，多目标优化后推荐串联方案。",
    "cover": "/research/wechat/2026-01-04-Qo6TMIVTHBvS0fdELjht2g/img03.webp",
    "images": 12,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2026-01-04-Qo6TMIVTHBvS0fdELjht2g/img02.webp"
      },
      {
        "type": "p",
        "text": "https://doi.org/10.1016/j.applthermaleng.2025.128677"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "为实现绿色航运，本研究提出了一种**基于LNG燃料船冷-热-电-碳高效转换的方法**，以实现零能耗增加的船舶碳捕集。文章建立有机朗肯循环-碳捕集（ORC-CCS）联合系统，对**串联式ORC-CCS（SORC-CCS）**和**并联式ORC-CCS（PORC-CCS）**进行了比较。主机燃烧烟气提供CO2解吸热，有机朗肯循环单元利用高品位LNG冷能，CO2液化单元利用低品位LNG冷能。SORC-CCS和PORC-CCS的ORC工质分别为R1270/R600和R1270/R290。随后，在基本工况下进行了能量、火用、经济性和环境（4E）分析。此外，对ORC-CCS系统进行了多目标优化。**结果表明，SORC-CCS和PORC-CCS均能实现零能耗的船载CO2捕集。**多目标优化显示，SORC-CCS的性能优于PORC-CCS，其能效乘以㶲效(ηen,sys*ηex,sys)为6.43%，避免的CO2排放量(ξ)为34.69%，碳捕集成本(CCC)为62.38美元/吨CO2。"
      },
      {
        "type": "h3",
        "text": "01 研究背景"
      },
      {
        "type": "p",
        "text": "国际海事组织（IMO）通过减排战略，要求 2030-2040 年船舶温室气体排放减少50%。因此航运业正迅速向零碳方向发展，船载碳捕集技术（OCCS）被视为最具前景的方法之一。"
      },
      {
        "type": "p",
        "text": "OCCS包括燃烧前捕集、富氧燃烧和燃烧后捕集，燃烧后捕集法的应用更加广泛。燃烧后捕集法中的化学吸收法（30%的MEA溶液）更适用于船载碳捕集，但 MEA 再生和 CO₂液化需大量冷热能耗，会降低船舶能效。本研究提出了基于 LNG 燃料船的 “冷 - 热 - 电 - 碳” 高效转换的船用 ORC-CCS系统，有望实现零能耗增加捕碳。此外，对比了两种系统构型（串联 SORC-CCS、并联 PORC-CCS），通过 4E（能量、火用、经济、环境）分析与多目标优化，确定最优方案。"
      },
      {
        "type": "h3",
        "text": "02 系统设计"
      },
      {
        "type": "h3",
        "text": "1. 系统构型与核心流程"
      },
      {
        "type": "p",
        "text": "以 81190 DWT LNG 散货船为研究对象（主机为 Wärtsilä 12V50DF，MCR 9930 kW），两种构型的核心设计均基于 “能量梯度利用”： **SORC-CCS（串联）**：无中间换热器，两个 ORC 串联梯级利用 LNG 冷能，缸套冷却水（JCW）为 ORC 热源。**PORC-CCS（并联）**：两个 ORC 通过中间换热器连接，JCW 为 PORC1 热源，LNG 为 PORC2 冷源。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-04-Qo6TMIVTHBvS0fdELjht2g/img03.webp"
      },
      {
        "type": "h3",
        "text": "图1.（a）SORC-CCS和（b）PORC-CCS的示意图。"
      },
      {
        "type": "h3",
        "text": "2. ORC 工质优化"
      },
      {
        "type": "p",
        "text": "基于 “无毒、ODP=0、低 GWP、临界温度高于循环最高温” 原则，通过系统发电量筛选最优工质："
      },
      {
        "type": "p",
        "text": "SORC-CCS最优工质：R1270/R600（发电量139.8 kW，为所有组合中最高）"
      },
      {
        "type": "p",
        "text": "PORC-CCS 最优工质：R1270/R290（发电量 164.2 kW，为所有组合中最高）"
      },
      {
        "type": "h3",
        "text": "3. 系统假设"
      },
      {
        "type": "p",
        "text": "系统稳态运行，忽略动能势能变化，LNG 按 100% 甲烷计，烟气组成为 8% H₂O、75% N₂、10% O₂、7% CO₂（摩尔分数）。"
      },
      {
        "type": "h3",
        "text": "03参数研究与多目标优化"
      },
      {
        "type": "h3",
        "text": "1. 关键参数影响（L/G 液气比、烟气流量mfg）"
      },
      {
        "type": "h3",
        "text": "（1）液气比（L/G：0.8-1.4）"
      },
      {
        "type": "p",
        "text": "**从图2、3、4、5**中可以看出，随着L/G增大，SORC-CCS净功率从71.1 kW降至14.1 kW，PORC-CCS从83.9 kW降至43.3 kW。SORC-CCS的㶲效率随L/G升高持续下降，PORC-CCS的㶲效率随L/G升高先升后降。CCC下降， ANZ上升。两种系统的ξ和PES均呈上升趋势。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-04-Qo6TMIVTHBvS0fdELjht2g/img04.webp",
        "caption": "图2. Wnet, ηen,sys 随L/G变化的曲线(mf g=14000 kg / h)"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-04-Qo6TMIVTHBvS0fdELjht2g/img05.webp",
        "caption": "图3. ηex,sys，ηex,LNG随L/G变化的曲线(mf g=14000 kg / h)"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-04-Qo6TMIVTHBvS0fdELjht2g/img06.webp"
      },
      {
        "type": "h3",
        "text": "图4. CCC和ANZ随L/G变化的曲线 (mf g=14000 kg / h)"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-04-Qo6TMIVTHBvS0fdELjht2g/img07.webp"
      },
      {
        "type": "h3",
        "text": "图5. PES曲线、ζ随L/G变化(mf g=14000 kg / h)"
      },
      {
        "type": "h3",
        "text": "（2）烟气流量（mfg：12000-20000 kg/h）"
      },
      {
        "type": "p",
        "text": "**图6、7、8、9**展示了各个指标随mf g变化的曲线。随着mfg增大，导致SORC-CCS和PORC-CCS的净功率下降（SORC从46.1 kW→-32.8 kW，PORC从66.4 kW→12.1 kW）。SORC-CCS系统火用效率轻微下降，PORC-CCS系统㶲效率显著提升。CCC显著降低，且SORC-CCS始终保持更低的CCC水平。SORC-CCS 和 PORC-CCS 系统的PES与ξ均呈上升趋势。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-04-Qo6TMIVTHBvS0fdELjht2g/img08.webp"
      },
      {
        "type": "h3",
        "text": "图6. Wnet, ηen,sys随mf g变化的曲线(L / G=1.2)"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-04-Qo6TMIVTHBvS0fdELjht2g/img09.webp"
      },
      {
        "type": "h3",
        "text": "图7. ηex,sys，ηex,LNG随mf g变化的曲线(L / G=1.2)"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-04-Qo6TMIVTHBvS0fdELjht2g/img10.webp"
      },
      {
        "type": "h3",
        "text": "图8. CCC、ANZ随mf g变化的曲线(L / G=1.2)"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-04-Qo6TMIVTHBvS0fdELjht2g/img11.webp"
      },
      {
        "type": "h3",
        "text": "图9. PES曲线，ζ随mf g变化的曲线(L / G=1.2)"
      },
      {
        "type": "h3",
        "text": "2. 多目标优化"
      },
      {
        "type": "p",
        "text": "结合 TOPSIS 和 LINMAP 筛选最优工况，结果如下："
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-04-Qo6TMIVTHBvS0fdELjht2g/img12.webp"
      },
      {
        "type": "h3",
        "text": "04核心结论与展望"
      },
      {
        "type": "h3",
        "text": "1. 核心结论"
      },
      {
        "type": "p",
        "text": "（1）基于LNG冷能和废热回收，SORC-CCS和PORC-CCS均实现了零增耗船上CO₂捕集。在基本工况下，二者的捕集率可达90%以上，PORC-CCS比 SORC-CCS的性能更优。"
      },
      {
        "type": "p",
        "text": "（2）关键参数影响规律：L/G 与mfg增大均会降低能量效率，增大 mfg 与 L/G 对SORC-CCS的㶲效率产生负面影响，但会对PORC-CCS系统的㶲效率产生一定的正面影响"
      },
      {
        "type": "p",
        "text": "（3）优化后 SORC-CCS 为推荐方案：在高烟气流量20000 kg/h、L/G=1.16时，ηen, sys*ηex,sys is 6.43 %, ξ is 34.69 %, CCC is 62.38 $/t CO2。"
      },
      {
        "type": "h3",
        "text": "2. 未来研究方向"
      },
      {
        "type": "p",
        "text": "（1）工质优化：探索 ORC 非共沸混合物工质、CCS 双相吸收剂，提升系统性能。"
      },
      {
        "type": "p",
        "text": "（2）设备改进：开发紧凑型高效塔器与换热器，适配船舶空间限制。"
      },
      {
        "type": "p",
        "text": "（3）动态分析：结合船舶航行工况（如负荷波动），建立动态系统模型，提升实用性。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2026-01-04-Qo6TMIVTHBvS0fdELjht2g/img13.webp"
      },
      {
        "type": "p",
        "text": "攥稿：师敏"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2025-12-28-W0rpt-Bs",
    "slug": "W0rpt-BsFYEkBqKLsxMYUQ",
    "title": "双结构液冷板 | 高容量储能电池液冷板肋片与凹坑结构的实验研究",
    "date": "2025-12-28",
    "source": "https://mp.weixin.qq.com/s/W0rpt-BsFYEkBqKLsxMYUQ",
    "primary": "extra",
    "projects": [
      "extra"
    ],
    "summary": "微通道两侧分别布置凹坑与肋片的双结构液冷板实验；凹坑面朝电池时最高温度降低 12.05%、温度标准差降低 55.8%。",
    "cover": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img03.webp",
    "images": 28,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img02.webp"
      },
      {
        "type": "p",
        "text": "https://doi.org/10.1016/j.est.2025.119711"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "随着可再生能源和储能技术的快速发展，高容量储能电池在运行过程中产生的热量不断增加，温度控制成为制约其安全性和寿命的关键问题。为此，本文提出了一种双结构液冷板（LCP），在微通道两侧分别布置凹坑和肋片结构，以强化传热性能。实验对比了凹坑面靠近电池（PCTB）和肋片面靠近电池（RCTB）两种布置方式，在不同体积流量（qv）、入口温度（Tin）和充放电倍率（CR）条件下，对电池组最高温度（Tmax）和温度均匀性（SD）进行了系统分析。结果表明，PCTB配置在冷却效果和温度均匀性方面均优于RCTB，在qv为1L/min时，Tmax最高降低12.05%，SD最高降低55.8%。"
      },
      {
        "type": "h3",
        "text": "01 研究背景"
      },
      {
        "type": "p",
        "text": "锂离子电池因其高能量密度、快充放电能力和长循环寿命，已成为动力与储能领域的主流技术，对能源绿色转型具有重要意义。然而，锂电池对温度高度敏感，其性能、安全性和寿命均依赖于良好的热环境。研究表明，电池在 20–40 ℃ 且温差不超过 5 ℃ 的条件下运行，可保持稳定性能并减缓衰减。随着能量密度和功率提升，电池产热显著增加，传统散热方式已难以满足温控和均匀性要求，因此，开发高效可靠的电池热管理技术已成为保障锂电池安全与性能的关键。"
      },
      {
        "type": "h3",
        "text": "02 实验描述"
      },
      {
        "type": "h3",
        "text": "1.实验装置"
      },
      {
        "type": "p",
        "text": "图 1 为实验装置示意图。实验在恒温恒湿箱内进行，环境温度设定为 45 ℃，以模拟极端工况。研究考察了qv（1–3 L/min）、Tin（13–23 ℃）及CR（0.5C–1C）对电池组Tmax 和SD 的影响，其中 qv、Tin 和充放电过程分别由齿轮泵、低温恒温槽和电池测试系统控制。"
      },
      {
        "type": "p",
        "text": "此外，为分析电池运行状态对液冷板对流换热系数 h 的影响，不同 CR 对应设置了充电、静置和放电工况：1C（1 h–0.5 h–1 h）、0.75C（1.3 h–0.5 h–1.3 h）和 0.5C（2 h–0.5 h–2 h）。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img03.webp"
      },
      {
        "type": "h3",
        "text": "图1.实验装置示意图"
      },
      {
        "type": "h3",
        "text": "2. LCP的物理模型"
      },
      {
        "type": "p",
        "text": "PCTB配置电池组如图2所示，图3为通道内部的结构详情。图4为具体的热阻及其温度分布，本研究计算中考虑的热阻对应于X方向的热阻。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img04.webp"
      },
      {
        "type": "h3",
        "text": "图2. 电池组及LCP的布置"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img05.webp"
      },
      {
        "type": "h3",
        "text": "图3. 带肋片结构的LCP几何示意图"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img06.webp"
      },
      {
        "type": "h3",
        "text": "图4. PCTB配置的温度梯度和热阻"
      },
      {
        "type": "h3",
        "text": "3. 不确定度分析"
      },
      {
        "type": "p",
        "text": "对于实验的不确定分析具体如下表："
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img07.webp"
      },
      {
        "type": "h3",
        "text": "03 结果分析与讨论"
      },
      {
        "type": "h3",
        "text": "1. 入口温度对于电池热管理系统的影响"
      },
      {
        "type": "p",
        "text": "图 5–7 分别展示了在 Tin 为 13、18 和 23 ℃ 条件下电池组 Tmax 和 SD 的变化情况。结果表明，PCTB 配置在冷却能力和温度均匀性方面均优于 RCTB，Tmax 最大降低 8.8%，SD 最大降低 50%。随着 Tin 的升高，液冷板整体冷却能力有所减弱，但电池组的温度均匀性呈现出一定程度的改善。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img08.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img09.webp"
      },
      {
        "type": "h3",
        "text": "图5. Tin为13℃时对于电池Tmax和SD的影响"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img10.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img11.webp"
      },
      {
        "type": "h3",
        "text": "图6. Tin为18℃时对于电池Tmax和SD的影响"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img12.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img13.webp"
      },
      {
        "type": "h3",
        "text": "图7. Tin为23℃时对于电池Tmax和SD的影响"
      },
      {
        "type": "p",
        "text": "不同的Tin和电池状态对应h(W/(m2·℃))的数值见下表："
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img14.webp"
      },
      {
        "type": "h3",
        "text": "2. 流量对于电池热管理系统的影响"
      },
      {
        "type": "p",
        "text": "如图8-10所示，随着体积流量 qv 从 1 L/min 增加至 3 L/min，电池组 Tmax 持续降低，但冷却性能提升幅度逐渐减小。相比 RCTB，PCTB 在各流量下均表现出更优的冷却效果与温度均匀性，Tmax 最大降低 12.05%，SD 最大降低 55.8%，表明凹坑面靠近电池的布置方式更有利于强化电池热管理性能。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img15.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img16.webp"
      },
      {
        "type": "h3",
        "text": "图8. qv为1L/min时对于电池Tmax和SD的影响"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img17.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img18.webp"
      },
      {
        "type": "h3",
        "text": "图9. qv为2L/min时对于电池Tmax和SD的影响"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img19.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img20.webp"
      },
      {
        "type": "h3",
        "text": "图10. qv为3L/min时对于电池Tmax和SD的影响"
      },
      {
        "type": "p",
        "text": "不同的Tin和电池状态对应h(W/(m2·℃))的数值见下表："
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img21.webp"
      },
      {
        "type": "h3",
        "text": "3. 充放电速率对于电池热管理的影响"
      },
      {
        "type": "p",
        "text": "如图11-13所示，随着 CR 从 0.5C 提高至 1C，电池组 Tmax 和 SD 均随产热增强而增加。相比 RCTB，PCTB 在各倍率下均保持更低的 Tmax，表明其在高倍率工况下具有更优的冷却性能，而在低倍率（0.5C）条件下，两种配置均能有效控制电池温度。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img22.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img23.webp"
      },
      {
        "type": "h3",
        "text": "图11. CR为0.5 C时对于电池Tmax和SD的影响"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img24.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img25.webp"
      },
      {
        "type": "h3",
        "text": "图12. CR为0.75 C时对于电池Tmax和SD的影响"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img26.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img27.webp",
        "caption": "图13. CR为1C时对于电池Tmax和SD的影响"
      },
      {
        "type": "h3",
        "text": "不同的Tin和电池状态对应h(W/(m2·℃))的数值见下表："
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img28.webp"
      },
      {
        "type": "h3",
        "text": "04 核心结论与展望"
      },
      {
        "type": "h3",
        "text": "1. 核心结论"
      },
      {
        "type": "p",
        "text": "(1) h 与电池状态密切相关。PCTB 和 RCTB 的 h 值分别为 1851.33–2987.59 W/(m²·℃) 和 1719.95–2906.76 W/(m²·℃)，且随电池状态变化的顺序为：静置 > 放电 > 充电。"
      },
      {
        "type": "p",
        "text": "(2) h值随CR值的增大而减小，但CR值越高h减小的速率越慢，说明放电倍率越大h减小的敏感性越低，放电时，当CR从0.5C增大到1C时，肋面h减小的速率降低了96.3%。"
      },
      {
        "type": "p",
        "text": "(3) 在所有条件下，PCTB 表现出更高的冷却效率和更均匀的温度分布。对于 PCTB，最大温度和温度标准偏差的范围分别为 27.37–40.50 ℃ 和 0.70–2.23 ℃；而对于 RCTB，这两个范围分别为 30.35–44.88 ℃ 和 0.94–2.82 ℃。。"
      },
      {
        "type": "h3",
        "text": "2. 未来研究方向"
      },
      {
        "type": "p",
        "text": "未来的研究可通过计算流体动力学模拟进一步验证和强化这些发现。此外，通过优化设计参数，如调整凹坑的深度、形状和布局，有望提升液体冷却板的性能，为大容量储能电池提供更高效的冷却解决方案。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-28-W0rpt-BsFYEkBqKLsxMYUQ/img29.webp"
      },
      {
        "type": "p",
        "text": "攥稿：张久魁"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2025-12-26-YhMPq-WV",
    "slug": "YhMPq-WVySGQYQYLZqotTg",
    "title": "恭喜课题组博士研究生入选《拔尖创新人才培养计划》",
    "date": "2025-12-26",
    "source": "https://mp.weixin.qq.com/s/YhMPq-WVySGQYQYLZqotTg",
    "primary": "news",
    "projects": [
      "news"
    ],
    "summary": "博士生田奕江入选学校《拔尖创新人才培养计划》，项目资助最高 8 万元。",
    "cover": "/research/wechat/2025-12-26-YhMPq-WVySGQYQYLZqotTg/img02.webp",
    "images": 1,
    "blocks": [
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "2025年10月，课题组**博士研究生田奕江**入选**《拔尖创新人才培养计划》。**项目资助最高8万元。"
      },
      {
        "type": "h3",
        "text": "项目简介"
      },
      {
        "type": "p",
        "text": "根据**“上海市一流研究生教育引领计划”**和**“上海市地方高水平大学建设规划”**的要求，我校每年支持20名博士研究生启动**2025年度研究生拔尖创新人才培养计划**。重点鼓励基础扎实、思维活跃、学有专长、有较强的科研兴趣和学术精神、科研潜力强的研究生，进入项目重点培养。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-12-26-YhMPq-WVySGQYQYLZqotTg/img02.webp"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2025-11-26-9mBJ_zyy",
    "slug": "9mBJ_zyybEhBrqhlC3u7xw",
    "title": "课题组成员参加工程热物理年会并作口头报告",
    "date": "2025-11-26",
    "source": "https://mp.weixin.qq.com/s/9mBJ_zyybEhBrqhlC3u7xw",
    "primary": "extra",
    "projects": [
      "extra"
    ],
    "summary": "工程热物理年会报告：纳米流体强化 MEA 吸收-解吸的阶段性工作；0.06%、30 nm SiO2 使吸收量提高 2.2%、解吸率提高 16.21%、再生能耗降低 17.6%。",
    "cover": "/research/wechat/2025-11-26-9mBJ_zyybEhBrqhlC3u7xw/img03.webp",
    "images": 4,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2025-11-26-9mBJ_zyybEhBrqhlC3u7xw/img02.webp"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "2025年**中国工程热物理学会学术年会**于10月31日至11月2日在北京召开。本次年会由中国工程热物理学会主办，中国科学院工程热物理研究所、轻型涡轮动力全国重点实验室和长时规模储能重点实验室承办，汇聚了来自全国高校、科研院所及工业界的7000余名专家学者、企业代表和青年科研人员，共同探讨工程热物理领域的前沿突破与产业应用，助力国家“双碳”战略与能源革命。我课题组硕士研究生欧阳喆、顾毓参加了此次会议。在工程热力学分会场上，**欧阳喆**、**顾毓**分别作了题为**《基于纳米颗粒强化的醇胺吸收法吸收-解吸CO2性能实验研究》**、**《基于机器学习的碳捕集系统性能预测研究》**的口头报告，分享了他们最近在相关课题方向的研究进展。"
      },
      {
        "type": "h3",
        "text": "01 报告摘要"
      },
      {
        "type": "p",
        "text": "硕士研究生**欧阳喆**作了题为**《基于纳米颗粒强化的醇胺吸收法吸收-解吸CO2性能实验研究》**的口头报告。"
      },
      {
        "type": "p",
        "text": "硕士研究生**顾毓**作了题为《**基于机器学习的碳捕集系统性能预测研究》**的口头报告。"
      },
      {
        "type": "h3",
        "text": "02 报告内容"
      },
      {
        "type": "h3",
        "text": "《基于纳米颗粒强化的醇胺吸收法吸收-解吸CO2性能实验研究》"
      },
      {
        "type": "p",
        "text": "该研究针对乙醇胺（MEA）吸收法捕集CO2吸收量低，再生能耗高等缺点，以MEA为基液，采用两步法制备纳米流体，进行CO2吸收-解吸实验，研究纳米颗粒种类（SiO2、TiO2、Fe2O3）、浓度和粒径对CO2吸收量、解吸率和再生能耗的影响。结果表明，浓度为0.06%，粒径为30nm的SiO2颗粒性能最佳。与空白MEA溶液相比，吸收量、解吸率和再生能耗分别优化了2.2%、16.21%和17.6%。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-11-26-9mBJ_zyybEhBrqhlC3u7xw/img03.webp"
      },
      {
        "type": "h3",
        "text": "《基于机器学习的碳捕集系统性能预测研究》"
      },
      {
        "type": "p",
        "text": "为研究碳捕集系统运行的性能，该研究收集了7% CO2浓度下的12,313个多工况实验数据，采用机器学习方法快速准确地预测系统的CO2输出体积流量、捕集效率、再生能耗与热效能四个性能指标。测试了不同算法在系统性能预测任务上的表现。结果表明，随机森林算法能够准确学习到操作参数与系统性能指标的关联，所有性能指标的R²均超过0.98。基于碳捕集系统的多目标优化分析，获得了系统的最优工况组合，为高效的碳捕集系统设计设定基准。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-11-26-9mBJ_zyybEhBrqhlC3u7xw/img04.webp"
      },
      {
        "type": "h3",
        "text": "03 中国工程热物理年会简介"
      },
      {
        "type": "p",
        "text": "中国工程热物理学会学术年会是我国工程热物理领域规模最大、影响力最广的综合性学术盛会。年会聚焦“双碳”战略，涵盖工程热力学、传热传质学、燃烧学等六大分支学科，通过学术报告、工业论坛、科技展览等多种形式，促进学术交流、技术转化和青年人才培养，是领域内专家学者和青年学子获取前沿动态、开展合作的重要平台。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-11-26-9mBJ_zyybEhBrqhlC3u7xw/img05.webp"
      },
      {
        "type": "p",
        "text": "攥稿：欧阳喆、顾毓"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2025-11-23-l-pHYrtD",
    "slug": "l-pHYrtDD7yZtN2rUQZo3g",
    "title": "课题组研究生参加中国航海学会学术年会并作口头报告",
    "date": "2025-11-23",
    "source": "https://mp.weixin.qq.com/s/l-pHYrtDD7yZtN2rUQZo3g",
    "primary": "shipborne",
    "projects": [
      "shipborne"
    ],
    "summary": "中国航海学会学术年会优秀论文：紧凑型船载碳捕集系统的参数优化与实验验证，捕集效率最高 88.6%，再生热最低 3.97 MJ/kgCO2。",
    "cover": "/research/wechat/2025-11-23-l-pHYrtDD7yZtN2rUQZo3g/img05.webp",
    "images": 6,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2025-11-23-l-pHYrtDD7yZtN2rUQZo3g/img02.webp"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "2025年10月23日-25日，**“2025年中国航海学术年会”**在北京举行。与会代表围绕“科技创新赋能绿色低碳智能航运”的主题，开展学术论文交流和博士生科研成果交流，分享科研成果，展示创新思路，共同推进航运业高质量发展。会议由中国航海学会主办，汇聚了来自中国航运业和各个高校的专家学者。我课题组**博士研究生田奕江**和**硕士研究生白云帆**参加了此次会议。"
      },
      {
        "type": "h3",
        "text": "01 报告摘要"
      },
      {
        "type": "p",
        "text": "会上，博士研究生田奕江投稿的论文**《紧凑型船载碳捕集系统参数优化与实验验证》**获评优秀论文，并作口头报告，分享了他们最近在相关课题方向的研究进展。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-11-23-l-pHYrtDD7yZtN2rUQZo3g/img03.webp",
        "caption": "图1.博士研究生田奕江"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-11-23-l-pHYrtDD7yZtN2rUQZo3g/img04.webp",
        "caption": "图2.硕士研究生白云帆"
      },
      {
        "type": "h3",
        "text": "02 报告内容"
      },
      {
        "type": "p",
        "text": "**船舶减碳路径的探索—碳捕集是船舶能源转型阶段的必然选择**。本文提出了一种新型紧凑型船舶碳捕集系统（COCCS）。该系统将再沸器与汽提塔整合为单一单元，通过内置盘管结构实现船舶烟气余热的利用。为提升COCCS运行效率，我们开展了参数优化研究，重点通过调整参数而非增加系统成本来降低能耗。为此建立了COCCS中试装置以获取多参数测试数据库。参数设计基于船舶实际排放气体，烟气输入浓度为4-10%，液气比（L/G）为2-6。通过调节解吸压力（1.1-2.1bar），实现了系统性能的显著提升并保持“无损耗增益特性”。"
      },
      {
        "type": "p",
        "text": "实验结果表明，在参数优化条件下，最高捕集效率达88.6%，最低再生热3.97MJ/kgCO2，最高循环容量0.27mol/mol。其中液气比优化使捕集效率提升15.06%，解吸压力优化则使再生热降低44%。本研究为现有及未来机载碳捕集装置的参数方案提供了支持，并强调了通过参数优化提升系统性能的潜力，且无需额外基础设施投资。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-11-23-l-pHYrtDD7yZtN2rUQZo3g/img05.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-11-23-l-pHYrtDD7yZtN2rUQZo3g/img06.webp"
      },
      {
        "type": "h3",
        "text": "03 中国航海学会简介"
      },
      {
        "type": "p",
        "text": "**中国航海学会**，英文名称：**CHINA INSTITUTE OF NAVIGATION**，缩写：**CIN**。是由从事航海科学技术工作的有关单位和人员自愿组成的全国性、学术性、非营利性社会组织，是中国共产党和政府联系航海科技工作者的“桥梁”和“纽带”，是国家发展航海科学技术事业和建设科技强国、海洋强国、交通强国、航运强国和21世纪海上丝绸之路的重要社会力量。中国航海学术年会由中国航海学会组织主办，中国航海学术年会是我国航海领域最具影响力的学术活动之一，旨在汇聚行业智慧，推动航海科技创新与发展。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-11-23-l-pHYrtDD7yZtN2rUQZo3g/img07.webp"
      },
      {
        "type": "p",
        "text": "攥稿：白云帆"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2025-11-20-7Ha4I-m5",
    "slug": "7Ha4I-m54tQgMQ8ZLVSr4A",
    "title": "磕盐小队初相聚，名人堂兄再续缘——课题组团建活动纪实",
    "date": "2025-11-20",
    "source": "https://mp.weixin.qq.com/s/7Ha4I-m54tQgMQ8ZLVSr4A",
    "primary": "news",
    "projects": [
      "news"
    ],
    "summary": "校友返校日团建，9 位毕业成员与 2025 级新生交流科研方向与研究生规划。",
    "cover": "/research/wechat/2025-11-20-7Ha4I-m54tQgMQ8ZLVSr4A/img03.webp",
    "images": 2,
    "blocks": [
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "10 月 25 日海大校友返校日，校园氛围热闹，课题组团建 “新老相会”，既供校友交流，也助 2025 级新生融入，活动由田老师主持，9 位毕业师兄与在校生参加。活动先由田老师介绍毕业师兄（含高校读博、企业工作等经历）及新生的本科背景与研究方向，帮双方认识。随后众人聚餐，温馨氛围为交流铺垫。餐后新老成员继续畅谈，新生请教科研、规划时间，还添加师兄联系方式，为后续沟通留便利。"
      },
      {
        "type": "h3",
        "text": "活动展示"
      },
      {
        "type": "p",
        "text": "当海大的树叶染上秋天的暖意，10月25日的校园因校友返校日更显热闹。我组借此契机，策划了一场\"新老相会\"的新生团建，特意邀请毕业师哥师姐\"回家\"。最终，9位毕业师兄如约而至，在读的高年级师兄师姐全程陪伴，与新生们共赴这场跨越届次的相聚盛会。"
      },
      {
        "type": "p",
        "text": "**图1.** 9位校友返校与田老师合影"
      },
      {
        "type": "p",
        "text": "活动的序章，由田老师亲自执笔。席上，田老师逐一介绍9位\"归队\"师兄：有扎根顶尖高校读博、在学术前沿持续攻关的\"科研追光者\"，有投身龙头企业研发、用技术破解行业难题的\"实战先锋\"。随后田老师从本科背景到确定的研究方向，逐一介绍2025级的新生，帮助毕业师兄快速熟悉课题组的\"新鲜血液\"，建立起对新一代成员的认知。介绍环节结束后，大家围坐席间，美食的香气与热烈的交谈声交织，为新老成员深入交流奠定了温馨的基础。"
      },
      {
        "type": "p",
        "text": "聚餐结束后，意犹未尽的新老成员们自发围坐在一起，继续深入交流，有的围绕特定科研方向向毕业师兄请教前沿技术，有的则探讨研究生阶段的时间规划。新生们纷纷拿出手机添加师兄们的联系方式，为后续的请教交流埋下伏笔。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-11-20-7Ha4I-m54tQgMQ8ZLVSr4A/img03.webp",
        "caption": "图2. 课题组新老成员合影"
      },
      {
        "type": "p",
        "text": "通过这场与已毕业的师兄的团建，让课题组的每一位同学都收获颇丰，不仅了解到了有关科研和就业的丰富经验，更是体会到了课题组“环环相扣、薪火相传”的精神内核。9位毕业师兄带着课题组的印记深耕各界后，以“引路人”身份重返分享所学，正是“昔为新生承薪火，今作传者续华章”。在读高年级师兄师姐作为“中坚力量”，承接经验并为新生搭建沟通桥梁，新生们则带着汲取的干货与前辈的期许开启科研之路，恰是“初登研途寻真智，承继薪火赴新程”。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-11-20-7Ha4I-m54tQgMQ8ZLVSr4A/img04.webp"
      },
      {
        "type": "p",
        "text": "攥稿：吴宇恒"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2025-09-05-SOQWAud1",
    "slug": "SOQWAud11w2awavXZLsR6Q",
    "title": "BTMS | 揭秘：仿生微通道液冷板如何给大容量船用电池高效降温？",
    "date": "2025-09-05",
    "source": "https://mp.weixin.qq.com/s/SOQWAud11w2awavXZLsR6Q",
    "primary": "extra",
    "projects": [
      "extra"
    ],
    "summary": "面向热带海洋环境的 280 Ah 船用电池，提出鱼骨仿生微通道冷板并派生四种结构；Case-4 最高温度与压降比螺旋蛇形板分别低 3.71% 和 75.16%。",
    "cover": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img02.webp",
    "images": 27,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img02.webp"
      },
      {
        "type": "p",
        "text": "https://doi.org/10.1016/j.applthermaleng.2025.128056"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "**电池热管理（BTMS）**对于保证大容量船用电池的安全运行至关重要。本研究提出了一种基础仿生型微通道冷却板（mini-channel cooling plates，MCP）来解决在热带地区的高温海洋环境中电池温度分布不均匀的问题。通过数值模拟，将该MCP与两种传统的蛇形MCPs比较了综合性能。**在基础仿生型MCP结构基础上，提出了四种优化结构，通过改变进水流量、进水温度和调整挡板倾斜角度，进一步降低能耗和温差。**结果表明，优化后的Case-4 MCP的最高温度（Tmax ）和压降（ΔP）比初始螺旋蛇形MCP降低了3.71 %和75.16 %。且Case-4的换热系数（hw）增加了14.72 %。参数分析表明，入口温度每增加2℃将导致电池Tmax 升高1.5℃。此外，当MCP倾斜角度超过10°时，电池Tmax 下降小于0.5%。"
      },
      {
        "type": "h3",
        "text": "01 研究背景"
      },
      {
        "type": "p",
        "text": "全球变暖已经危及人们的生存环境，各国对构建绿色低碳环境的必要性达成了共识。国际航运业严重依赖化石燃料作为推进能源，导致其温室气体排放量占全总排放量的3%。优化船舶动力系统的设计和配置可以实现更高清洁水平。除了采用天然气、氨、甲醇和氢气等替代燃料，锂电池和风能太阳能发电系统等创新电力推进技术也有助于减少海上作业中的碳足迹。"
      },
      {
        "type": "p",
        "text": "**BTMS** 依据传热介质类型差异，可细分为**空气冷却**、**相变冷却**、**液体冷却**及**热管冷却**四种技术路径；根据传热路径设计不同，可区分为**直接接触式**和**间接接触式**。相对于直接液体冷却，间接冷却不仅具有传热系数大、不易泄漏，而且能为电池提供结构支撑和集成，既提升了安全性又节省了空间。"
      },
      {
        "type": "p",
        "text": "为了适应热带地区的极端环境条件并提供充足的电力，**本文的研究对象是一款容量为 280 Ah的棱柱形锂离子电池。工作条件设定在热带地区的高温海洋环境中，这与陆地环境相比具有独特的挑战性。**鱼骨架的结构特点是有一个中央主流，再向外延伸出分支。基于其结构特点，本研究设计了四个仿生微通道液冷板。通过数值模拟，研究当环境温度（Tamb）设定为 40°C 时，仿生微通道液冷板对电池模块的Tmax和 SD 的影响，同时对MCP 本身的综合性能进行了评估，以确定冷却板的最佳综合性能。"
      },
      {
        "type": "h3",
        "text": "02 图文分析"
      },
      {
        "type": "h3",
        "text": "2.1. 几何模型"
      },
      {
        "type": "p",
        "text": "考虑到电池模块的对称性，可以对模型进行简化，计算单元由两个半电池和一个微型冷却板组成，如**图1（b）**所示。仿生MCP的结构**如图2**所示，详细尺寸如**表1**所示。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img03.webp",
        "caption": "图1. 液冷电池模块"
      },
      {
        "type": "p",
        "text": "**图2.** MCPs结构示意图"
      },
      {
        "type": "p",
        "text": "**表1.** 微型通道冷却板结构参数"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img05.webp"
      },
      {
        "type": "h3",
        "text": "2.2. 基础结构的比较分析"
      },
      {
        "type": "p",
        "text": "先前的研究表明，通道中的速度分布对冷板的冷却性能有很大的影响。因此，通道间的速度一致性的调节是提高液板冷却性能的关键。本节将传统螺旋蛇形通道（Spiral serpentine channel，SSC）、蛇形通道（Serpentine channel，SC）和基础仿生通道（Basic bionic mini-channel，BBM）进行了比较，三块 MCP 的结构如**图 3**所示。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img06.webp",
        "caption": "图3. 基础微通道的结构"
      },
      {
        "type": "p",
        "text": "从**图4**和**图5**可以看出，SC、BBM冷板下的电池的温度低于SSC。**表2**是SSC、SC和BBM冷板的性能。与SSC相比，SC的ΔP上升了35.8%。使用 BBM 的电池单元的 Tmax 比 SSC 低了3.83%。SC和BBM的hw分别比SSC低了18.88%和12.87%。但BBM的ΔP比SSC低了 59.45%。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img07.webp",
        "caption": "图4. BTMS温度云图"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img08.webp",
        "caption": "图5. MCPs的速度云图与温度云图"
      },
      {
        "type": "p",
        "text": "**表2.** SSC，SC，BBM冷板的性能"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img09.webp"
      },
      {
        "type": "h3",
        "text": "2.3. 优化结构的比较分析"
      },
      {
        "type": "p",
        "text": "在上一节中，与 SC 相比，BBM 的 ΔP 显著降低，而 Tmax 则略有增加。在本节中，通过调整冷板的流道形状以实现更好的性能。四个 MCPs 的修改结构如图 2 所示。"
      },
      {
        "type": "p",
        "text": "**图 6**展示了在不同 MCPs 配置下电池的瞬态温度云图。它们的 Tmax 之间没有显著差异，但所有 MCPs 都能将电池温度保持在合理范围内。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img10.webp",
        "caption": "图6. 优化后的BTMS的温度云图"
      },
      {
        "type": "p",
        "text": "**图 7** 显示，带有 Case-1的电池温度最高。四种MCPs的标准偏差如**图 8** 所示。四种MCPs的标准偏差分别为 1.74℃、1.90℃、1.76℃和 1.91℃，均未超过 5℃。此外，电池的SD曲线呈现出先上升、后下降、再上升的趋势。具有 Case-1的电池模组的SD最小，而 Case-4 的SD最大。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img11.webp",
        "caption": "图7. 电池模组的Tmax"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img12.webp",
        "caption": "图8 电池模组的SD"
      },
      {
        "type": "p",
        "text": "**图9**显示了四个MCPs的温度云图、压力云图和速度云图。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img13.webp",
        "caption": "图9. 四块优化仿生MCPs的温度云图，压力云图和速度云图"
      },
      {
        "type": "p",
        "text": "在**表 3**可以看，Case-4和Case-2相对于Case-1表现出更出色的整体性能，而Case-3的整体性能较差。需要注意的是，PEC 并非唯一决定标准。更高的PEC会导致更高的冷却效率，但与图13中所示的SD的趋势相反。"
      },
      {
        "type": "p",
        "text": "**表3.** 四块优化仿生液冷板的性能"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img14.webp"
      },
      {
        "type": "h3",
        "text": "2.4. 入口质量流量的影响"
      },
      {
        "type": "p",
        "text": "在规定的入口质量流量范围内，Case-4的PEC始终是最高的，这意味着当qm = 1.6 g/s时，其相较于Case-3提高了 6.80%，相较于Case-2提高了 2.62%。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img15.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img16.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img17.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img18.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img19.webp",
        "caption": "图10 入口质量流量对四块液冷板性能的影响（a）Tmax;（b）SD;（c）换热系数;（d）压降;（e）PEC系数。"
      },
      {
        "type": "h3",
        "text": "2.5. 入口温度的影响"
      },
      {
        "type": "p",
        "text": "分析发现，当改变入口温度时，Case-2和Case-4表现出更高的hw，而Case-3 表现出较低的hw. 这与PEC 结果相对应，因此PEC结果是合理的。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img20.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img21.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img22.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img23.webp",
        "caption": "图11 入口温度对四块液冷板性能的影响（a）Tmax;（b）SD;（c）换热系数;（d）PEC系数"
      },
      {
        "type": "h3",
        "text": "2.6. 倾斜角度的影响"
      },
      {
        "type": "p",
        "text": "当倾斜区域的倾斜角度不断增大至20°，冷却板综合性能已小于1。它表明一直增大倾角并不总是产生正反馈。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img24.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img25.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img26.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img27.webp"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img28.webp",
        "caption": "图12 倾斜角度对四块液冷板性能的影响（a）Tmax;（b）SD;（c）换热系数;（d）压降;（e）PEC系数"
      },
      {
        "type": "h3",
        "text": "03 结论"
      },
      {
        "type": "p",
        "text": "本研究的主要结论如下："
      },
      {
        "type": "p",
        "text": "(1)改变入口质量流量对电池的均匀性影响最大，Case-1冷却板将电池的SD控制到最低水平。当质量流量在1.6 g/s及以下时，所有冷却板基本都能将SD控制在2°C以下。"
      },
      {
        "type": "p",
        "text": "(2)当改变入口温度时，Case-4具有最高的 PEC。此外，改变入口温度对电池的Tmax 和SD影响较大，但对冷却板的换热能力影响有限。"
      },
      {
        "type": "p",
        "text": "(3)随着倾斜角度的增大，MCPs的换热性能得到改善。但是一直增加倾斜角度并没有持续改善电池SD，表明不宜一直增大倾斜角度，倾斜角度为15°时综合效果最佳。"
      },
      {
        "type": "p",
        "text": "(4)综合考虑电池模组的最高温度、温度均匀性和冷板性能三个方面，倾斜角度为15°的Case-4表现最好。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-09-05-SOQWAud11w2awavXZLsR6Q/img29.webp"
      },
      {
        "type": "p",
        "text": "攥稿：韦英琦"
      },
      {
        "type": "p",
        "text": "编辑：江城"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2025-08-31-Jf38hTkK",
    "slug": "Jf38hTkKUW9lksexJ_izpw",
    "title": "会议 | 课题组成员投稿中国制冷空调专业产学研论坛获评优秀论文",
    "date": "2025-08-31",
    "source": "https://mp.weixin.qq.com/s/Jf38hTkKUW9lksexJ_izpw",
    "primary": "pche",
    "projects": [
      "pche"
    ],
    "summary": "中国制冷空调专业产学研论坛优秀论文：214×56.5×41.5 mm 锯齿通道 PCHE 传热与流动实验，逆流换热量比顺流高 1.1–1.8 kW。",
    "cover": "/research/wechat/2025-08-31-Jf38hTkKUW9lksexJ_izpw/img03.webp",
    "images": 4,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2025-08-31-Jf38hTkKUW9lksexJ_izpw/img02.webp"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "2025年8月26—27日，**第七届“中国制冷空调专业产学研论坛”**在西安成功举办。论坛由西安交通大学、中国制冷空调工业协会、合肥通用机械研究院有限公司、清华大学、中国制冷学会共同发起和组织，来自制冷空调行业产业界、学术界、研究机构和应用领域的260多位嘉宾和代表参加了大会。我课题组**硕士研究生曾励强**参加了此次会议。"
      },
      {
        "type": "h3",
        "text": "01 获奖内容"
      },
      {
        "type": "p",
        "text": "硕士研究生**曾励强**投稿的论文**《锯齿型通道印刷电路板换热器在低温条件下的热工水力性能实验研究》**获评**优秀论文**，论文展示了他们在相关课题方向的研究进展。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-31-Jf38hTkKUW9lksexJ_izpw/img03.webp",
        "caption": "图1.右2为课题组成员曾励强"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-31-Jf38hTkKUW9lksexJ_izpw/img04.webp",
        "caption": "图2.获奖证书"
      },
      {
        "type": "h3",
        "text": "02 摘要"
      },
      {
        "type": "p",
        "text": "**印刷电路板换热器（PCHE）**具有优异的热工水力性能和紧凑的结构，是液化天然气船燃料供应系统（FGSS）的理想汽化器。本文以尺寸为214mm×56.5mm×41.5mm的锯齿型通道PCHE作为研究对象，设计并搭建了一个**PCHE热工水力性能实验平台**，并以液氮(LN)作为冷流体，50%乙二醇水溶液(EG)作为热流体。通过调整EG进口质量流量（983-1621kg/h）、LN进口质量流量（50-110kg/h）和顺/逆流布置进行了传热和流动实验。首先研究了液氮和乙二醇质量流量的变化对流动换热性能的影响，其次比较了PCHE在顺流和逆流布置下的热工水力性能，最后分析了PCHE在低温环境下的冻结影响。"
      },
      {
        "type": "p",
        "text": "**结果表明**，增加液氮和乙二醇的质量流量会提高换热器的传热性能，且提高液氮质量流量产生的效果更加显著。与顺流相比，PCHE在逆流条件下的换热性能更高，在LN质量流量相同的情况下，逆流排布的换热量要比顺流排布的换热量高出1.1-1.8kW。当换热器局部发生冻结时，其传热性能会显著恶化，且压降也会大幅度提高。该研究为PCHE作为低温蒸发器提供了参考，为其在FGSS中的应用奠定的基础。"
      },
      {
        "type": "h3",
        "text": "03 会议简介"
      },
      {
        "type": "p",
        "text": "中国制冷空调专业产学研论坛，由已故西安交大教授吴业正先生在2010年提议和倡导。自2011年8月在西安举办第一届以来，建立起了中国制冷空调专业产学研技术交流和信息共享平台，交流产学研技术、经验，努力推进成果的对接及转化。面向国家“碳中和”能源发展战略和企业技术发展，探索提升我国制冷空调领域技术水平与创新能力的路径，推进了中国制冷空调行业和制冷空调学科可持续发展。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-31-Jf38hTkKUW9lksexJ_izpw/img05.webp"
      },
      {
        "type": "p",
        "text": "攥稿：曾励强"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2025-08-23-GGlaoA2v",
    "slug": "GGlaoA2vmq4o1dxgERAXrw",
    "title": "ExHFT-11 | 汇报分享课题组在锯齿通道PCHE在低温液氮汽化过程的热工水力性能的研究进展",
    "date": "2025-08-23",
    "source": "https://mp.weixin.qq.com/s/GGlaoA2vmq4o1dxgERAXrw",
    "primary": "pche",
    "projects": [
      "pche"
    ],
    "summary": "ExHFT-11 报告：锯齿通道 PCHE 低温液氮汽化实验，考察质量流量、进口温度与并/逆流布置；逆流换热更优但更易冻结，面向 LNG 船 FGSS 汽化器。",
    "cover": "/research/wechat/2025-08-23-GGlaoA2vmq4o1dxgERAXrw/img04.webp",
    "images": 4,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2025-08-23-GGlaoA2vmq4o1dxgERAXrw/img02.webp"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "2025年8月15日-18日，**第十一届国际实验传热学、流体力学和热力学会议(The World Conference on Experimental Heat Transfer, Fluid Mechanics and Thermodynamics)**在北京成功举办。会议由华北电力大学牵头主办，西安交通大学、中科院工程热物理研究所和航空动力系统与等离子体技术全国重点实验室等机构联合协办。大会汇聚了来自中国、日本、韩国、英国、美国、加拿大等20余个国家和地区的近500位专家学者。我课题组**博士研究生卢昱礽**参加了此次会议。"
      },
      {
        "type": "h3",
        "text": "01 报告内容"
      },
      {
        "type": "p",
        "text": "会上，博士研究生卢昱礽作了题为《Experimental Study on the Vaporization of Liquid Nitrogen in zigzag PCHE under Low Temperature Conditions》的口头报告，分享了他们最近在相关课题方向的研究进展。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-23-GGlaoA2vmq4o1dxgERAXrw/img03.webp"
      },
      {
        "type": "h3",
        "text": "02 摘要"
      },
      {
        "type": "p",
        "text": "本文通过实验研究了锯齿形通道印刷电路板式换热器（PCHE）在低温条件下液氮汽化过程的热工水力性能。实验采用液氮（LN₂）与50%乙二醇/水溶液（EG/W）作为工质，系统考察了质量流量、入口温度及流动布置（并流与逆流）对换热特性与压降的影响。结果表明，提高液氮质量流量可显著增强换热能力（最大提升近100%），但同时也导致压降显著上升；逆流布置虽换热性能优于并流，却更容易引发冻结现象；提高乙二醇入口温度与流量可有效抑制PCHE内部冻结风险，提升系统运行稳定性。该研究为PCHE在液化天然气（LNG）船舶燃料供应系统（FGSS）中的低温汽化器应用提供了重要实验依据。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-23-GGlaoA2vmq4o1dxgERAXrw/img04.webp"
      },
      {
        "type": "p",
        "text": "本次会议为工业界和学术界的研究人员提供一个国际论坛，展示传热、流体力学和热力学以及跨学科领域的新研究理念、先进方法、和研究成果。我课题组学生在其研究方向上获得了诸多启示。这些学术交流也为我课题组PCHE高效传热研究提供了新的思路。"
      },
      {
        "type": "h3",
        "text": "03 ExHFT会议简介"
      },
      {
        "type": "p",
        "text": "自1988年首次举办以来，ExHFT系列会议(The World Conference on Experimental Heat Transfer, Fluid Mechanics and Thermodynamics)已成为传热学、流体力学和热力学全球学术界最具权威的盛事之一，每四年举办一届，备受全球学者关注。ExHFT-11会议首次在中国举办，是全球研究人员交流实验传热、流体力学和传热学前沿进展的重要平台。会议涵盖了从基础研究到工业应用的广泛主题，设计传热、流体力学、热力学、机器学习、能源、可持续、碳中和、工程设计与实践等关键领域。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-23-GGlaoA2vmq4o1dxgERAXrw/img05.webp"
      },
      {
        "type": "p",
        "text": "攥稿：卢昱礽"
      },
      {
        "type": "p",
        "text": "编辑：田奕江"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  },
  {
    "id": "2025-08-21-KpvOeaz1",
    "slug": "KpvOeaz1gZJBeTrS3N8q4A",
    "title": "COCCS | 紧凑船舶碳捕集系统试验为船舶减碳提供新视角",
    "date": "2025-08-21",
    "source": "https://mp.weixin.qq.com/s/KpvOeaz1gZJBeTrS3N8q4A",
    "primary": "shipborne",
    "projects": [
      "shipborne"
    ],
    "summary": "紧凑船载碳捕集试验系统 COCCS 把再沸器集成进解吸塔，用实船烟气数据设计工况。仅靠参数调节即可把再生热降低 62.5%，最低 3.92 MJ/kgCO2。",
    "cover": "/research/wechat/2025-08-21-KpvOeaz1gZJBeTrS3N8q4A/img04.webp",
    "images": 9,
    "blocks": [
      {
        "type": "img",
        "src": "/research/wechat/2025-08-21-KpvOeaz1gZJBeTrS3N8q4A/img02.webp"
      },
      {
        "type": "p",
        "text": "https://doi.org/10.1016/j.jclepro.2025.146362"
      },
      {
        "type": "h2",
        "text": "全文速览"
      },
      {
        "type": "p",
        "text": "随着双碳战略进一步加深，船舶碳捕集需求显著增长。船载碳捕集系统（OCCS）因为在航运业碳减排领域中的巨大潜力而受到高度关注。本文测试了紧凑船载碳捕集试验系统（COCCS），该系统集成内热再沸器提高空间利用和传热效率，使用船舶烟气数据作为试验系统工况设计进行参数研究，特别提出了具有“无损增益”特性的调节手段，解吸压力调节，使得再生热大幅度降低。研究发现，仅通过参数调节能够降低62.5%的再生热，达到3.92MJ/kgCO2，解吸压力的调节使得捕集率和再生热具有选择性，单解吸压力调节能够降低44%的再生热。"
      },
      {
        "type": "h3",
        "text": "01 研究背景"
      },
      {
        "type": "p",
        "text": "全球贸易量的80%以上是通过航运业实现的。航运占全球排碳量的3%，相当于全球第六大碳排放国家。如果不采取对应措施，碳排放还会持续增加。为了避免环境进一步恶化，国际海事组织（IMO）通过颁布一系列措施积极应对，即采用基于市场的措施，碳税或排放交易系统（ETS），和提高船舶能效设计指数（EEDI）的方法，以促进低碳燃料和技术的发展。"
      },
      {
        "type": "p",
        "text": "船载碳捕集（OCCS）作为一种减碳技术，在航运业具有特别的应用价值。它不仅能够使得船舶满足EEDI的要求，还有二氧化碳产出，减少系统运行成本。**然而，尽管碳捕集技术潜力巨大，但是在船舶领域的应用相对较少，这主要取决于缺乏对航运特殊领域碳捕集系统和船舶系统的耦合性研究和船舶碳捕集的需求和陆地碳捕集需求不同的差异导致的。**"
      },
      {
        "type": "p",
        "text": "**本研究通过耦合船舶系统的试验研究，对多种参数组合进行精确评估，找出针对船舶系统的特殊调控方式，旨在填补现有研究中的这一空白。**该系统使用高度集成的解吸塔，能够直接利用烟气余热。尽管已经有多种优秀的吸收剂，该系统仍然使用传统MEA溶液（方便优化对比），依然可以体现出优化导致的性能巨大提升。此外，这一研究所展示的不同工况下的参数变化能够匹配船舶航线负载的动态变化，这为COCCS系统匹配船舶运行情况而动态调整参数提供依据。"
      },
      {
        "type": "h3",
        "text": "02 图文分析"
      },
      {
        "type": "h3",
        "text": "1.COCCS试验系统描述"
      },
      {
        "type": "p",
        "text": "该系统（图1）分为三个模块，绿色区域表示船舶烟气模拟系统，蓝色区域模拟海水冷却系统，红黄区域表示捕集循环系统。其中再沸器使用水蒸气模拟烟气余热。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-21-KpvOeaz1gZJBeTrS3N8q4A/img03.webp",
        "caption": "图1. COCCS试验系统图"
      },
      {
        "type": "p",
        "text": "系统实验台实物图如图2。集成再沸器设计如图3所示。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-21-KpvOeaz1gZJBeTrS3N8q4A/img04.webp",
        "caption": "图2 系统实物图。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-21-KpvOeaz1gZJBeTrS3N8q4A/img05.webp",
        "caption": "图3 再沸器设计图。"
      },
      {
        "type": "h3",
        "text": "2.CCO2变化对系统性能的影响"
      },
      {
        "type": "p",
        "text": "本研究中烟气浓度的变化主要匹配于船舶烟气的波动范围。从图4中可以看出，烟气的浓度在4%-7%之间波动。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-21-KpvOeaz1gZJBeTrS3N8q4A/img06.webp",
        "caption": "图4. 实际航行中CO₂测量及CO₂浓度变化。"
      },
      {
        "type": "p",
        "text": "从图5-6中可以看出烟气浓度提高捕集量的提高贡献较大，捕集率则相反。从碳负荷可以看出低浓度的烟气不足以发挥吸收剂的全部能力。烟气浓度的提高对再生热的降低有巨大贡献。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-21-KpvOeaz1gZJBeTrS3N8q4A/img07.webp",
        "caption": "图5 捕集率和捕集量随烟气浓度的变化。"
      },
      {
        "type": "p",
        "text": "**图6** CO2负荷和循环容量随烟气浓度的变化。"
      },
      {
        "type": "h3",
        "text": "3.L/G变化对系统性能的影响"
      },
      {
        "type": "p",
        "text": "L/G作为碳捕集系统（CCS）的核心参数，决定着系统的主要性能。从图7可以看出，L/G变化导致捕集率存在峰值。从图8可以看出L/G的提升对吸收剂的性能起抑制作用。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-21-KpvOeaz1gZJBeTrS3N8q4A/img09.webp",
        "caption": "图7 捕集率和捕集量随L/G的变化。"
      },
      {
        "type": "p",
        "text": "**图8** CO2负荷和循环容量随L/G的变化。"
      },
      {
        "type": "h3",
        "text": "4.解吸压力变化对系统性能的影响"
      },
      {
        "type": "p",
        "text": "解吸压力的调节是针对船舶碳捕集系统（OCCS）控制的核心控制手段，具有“无损增益特性”。从图9-10中可以看出，压力提高伴随着蒸汽温度的提高，从而提高了解吸性能。但是过高的压力导致性能下下降是因为热量不足和二氧化碳分压过高导致的。若能改善将会是巨大的提升。"
      },
      {
        "type": "p",
        "text": "**图9** 捕集率和捕集量随Pdes的变化。"
      },
      {
        "type": "p",
        "text": "**图10** CO2负荷和循环容量随Pdes的变化。"
      },
      {
        "type": "p",
        "text": "从图11中看出，吸收剂负荷的上限和二氧化碳分压的提高都是抑制性能的表现。对于船舶系统来说，至关重要的参数变化如图12。相反于捕集系统的其他参数，再生热变化格外有吸引力。随着解吸压力提高，系统再生热降低达到44%，主要体现在潜热的降低。"
      },
      {
        "type": "p",
        "text": "**图11** 捕集率和捕集量随Pdes的变化。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-21-KpvOeaz1gZJBeTrS3N8q4A/img14.webp",
        "caption": "图12 CO2负荷和循环容量随Pdes的变化。"
      },
      {
        "type": "p",
        "text": "这样的变化对于陆地碳捕集来说并不具备吸引力，但是对于需要满足EEDI和CII的船舶来说具有额外的意义。解吸压力的调节对系统的整体作用可以归结于牺牲捕集率降低再生热。捕集率的适当降低对于满足EEDI和CII来说影响并不大。但是再生热的大幅度降低对船舶系统来说有巨大增益。同时这种简单的调节方式和巨大的性能调整，对于船舶系统动态变化的调节提供极大便利。"
      },
      {
        "type": "h3",
        "text": "03 结论"
      },
      {
        "type": "p",
        "text": "本研究表明，紧凑碳捕集系统（COCCS）在船舶领域碳减排方面有巨大的潜力，尤其是针对船舶满足EEDI和SEEMP以及船舶航行过程中的动态匹配。船舶通过部署COCCS，可以在短期内满足EEDI和SEEMP的要求。同时，更低的再生热为船舶的日常运行降低大量成本。"
      },
      {
        "type": "p",
        "text": "未来发展方向应该包括COCCS对船舶航行过程中动态过程的匹配，二氧化碳对更高价值产品的转化，数字AI对于系统匹配性应用的结合。本研究为航运业的OCCS发展提供了科学依据和策略建议，通过定量评估分析，帮助制定实现碳减排目标的可持续政策。"
      },
      {
        "type": "img",
        "src": "/research/wechat/2025-08-21-KpvOeaz1gZJBeTrS3N8q4A/img15.webp"
      },
      {
        "type": "p",
        "text": "编辑：江城"
      },
      {
        "type": "p",
        "text": "审核：悠悠"
      }
    ]
  }
];

export const articleById = new Map(articles.map((article) => [article.id, article]));

export function articlesForProject(projectId: string): WechatArticle[] {
  return articles
    .filter((article) => article.projects.includes(projectId))
    .sort((a, b) => {
      if (a.primary !== b.primary) return a.primary === projectId ? -1 : 1;
      return b.date.localeCompare(a.date);
    });
}
